export default {
  home: {
    en: {
      lead1: "Unlock Your Teaching Potential<br />with Explore2Teach",
      lead2: `Explore global and nationwide teaching opportunities, enhance your
                skills, and<br />make a lasting impact. Whether you are an
                international educator or a teacher already in the<br />U.S. seeking
                your next opportunity, we’re here to support your journey.`,
      studyInUS: "Want to study in the U.S.?",
      registerNow: "Register Now",
      lead3: "Your Path to Teaching Opportunities",
      createAccount: "Create an Account",
      step1:
        "Set up your profile and begin your journey to teaching opportunities with schools and partner institutions across our network.",
      uploadCredentials: "Upload Credentials",
      step2:
        "Upload your credentials to highlight your experience and qualifications, enabling our AI-powered matching system to connect you with teaching opportunities that align with your expertise.",
      applicationStatus: "Application Status",
      step3:
        "Track the progress of your application and stay updated on next steps.",
      candidateSupport: "Candidate Support",
      step4:
        "Receive comprehensive support, including housing assistance, relocation services for a seamless transition, and professional development resources to help you excel in your teaching journey.",
      learnMore: "Learn More",
      exploreAffiliatedSchools: "Explore Affiliated Schools",
      partneredSchools: "List of Partnered Schools",
      subscribeNow: "Subscribe to Explore2Teach",
      subscribeMessage:
        "Sign up today to explore exciting teaching opportunities across the U.S. with Explore2Teach!",
      followUs: "Follow us:",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      contactNumber: "Contact Number",
      country: "Country",
      selectCountry: "Select Country",
      subscribeButton: "Subscribe now",
      subscribeDisclaimer:
        "By submitting, you’ll receive valuable updates and resources to support your global teaching journey.",
      placeHolderFirstName: "Enter First Name",
      placeHolderLastName: "Enter Last Name",

    },
    es: {
      lead1: "Desbloquea Tu Potencial Docente<br />con Explore2Teach",
      lead2: `Explora oportunidades de enseñanza a nivel global y nacional, mejora tus
                habilidades y<br />deja una huella duradera. Ya seas un educador
                internacional o un docente que ya se encuentra en<br />EE.UU. en busca de
                su próxima oportunidad, estamos aquí para apoyar tu camino.`,
      studyInUS: "¿Quieres estudiar en los EE.UU.?",
      registerNow: "Regístrate Ahora",
      lead3: "Tu Camino hacia Oportunidades de Enseñanza",
      createAccount: "Crea una Cuenta",
      step1:
        "Crea tu perfil y comienza tu camino hacia oportunidades de enseñanza con escuelas e instituciones asociadas de nuestra red.",
      uploadCredentials: "Sube tus Credenciales",
      step2:
        "Sube tus credenciales para resaltar tu experiencia y calificaciones, permitiendo que nuestro sistema de emparejamiento impulsado por IA te conecte con oportunidades de enseñanza acordes a tu perfil.",
      applicationStatus: "Estado de la Solicitud",
      step3:
        "Sigue el progreso de tu solicitud y mantente informado sobre los próximos pasos.",
      candidateSupport: "Soporte al Candidato",
      step4:
        "Recibe un apoyo integral, incluyendo asistencia con la vivienda, servicios de reubicación para una transición sin problemas y recursos de desarrollo profesional para que destaques en tu carrera docente.",
      learnMore: "Saber Más",
      exploreAffiliatedSchools: "Explora Escuelas Afiliadas",
      partneredSchools: "Lista de Escuelas Asociadas",
      subscribeNow: "Suscríbete a Explore2Teach",
      subscribeMessage:
        "¡Regístrate hoy para descubrir emocionantes oportunidades de enseñanza en EE.UU. con Explore2Teach!",
      followUs: "Síguenos:",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo Electrónico",
      contactNumber: "Número de Contacto",
      country: "País",
      selectCountry: "Selecciona un País",
      subscribeButton: "Suscribirse Ahora",
      subscribeDisclaimer:
        "Al enviar, recibirás actualizaciones valiosas y recursos para apoyar tu camino docente global.",
      placeHolderFirstName: "Ingresa Nombre",
      placeHolderLastName: "Ingresa Apellido",
    }
  },
  teacherResources: {
    en: {
      title: 'How We Can Help',
      housing_resources: 'Housing Resources',
      relocation_support: 'Relocation Support',
      community_engangement: 'Community Engagement',
      see_more: 'SEE MORE',
    },
    es: {
      title: 'Cómo Podemos Ayudarte',
      housing_resources: 'Recursos de Vivienda',
      relocation_support: 'Apoyo para la Reubicación',
      community_engangement: 'Participación Comunitaria',
      see_more: 'VER MÁS',
    }
  },

  pageHeader: {
    en: {
      login: 'login',
      home: 'Home',
      about: 'About Us',
      explore: 'Explore',
      teach: 'Teach',
      contact_us: 'Contact Us',
      keyword: 'Enter Your Keyword ...',
    },
    es: {
      login: 'Iniciar sesión',
      home: 'Inicio',
      about: 'Sobre Nosotros',
      explore: 'Explorar',
      teach: 'Enseñar',
      contact_us: 'Contáctanos',
      keyword: 'Ingresa tu palabra clave ...',
    }
  },
  pageFooter: {
    en: {
      copyright: 'Copyright 2024 by',
      reserved: 'All rights Reserved',
      title: 'Explore2Teach',
      year: '2024',
    },
    es: {
      copyright: 'Derechos de Autor 2024 por',
      reserved: 'Todos los derechos reservados',
      title: 'Explore2Teach',
      year: '2024',
    }

  },
  aboutUs: {
    en: {
      des: "Explore2Teach is more than just a platform – it’s a movement. We unite educators worldwide, opening doors to new opportunities, transformative training, and a powerful community. Here, teachers don’t just grow—they inspire, lead, and redefine the future of education.",
      mission: "The Founder’s Mission and Vision",
      founder: "Melody and Neriza",
      founder_des: "Driven by their shared passion for education, Melody and Neriza founded Explore2Teach with the vision of helping educators find meaningful roles and supporting schools in their search for the right talent. Committed to creating opportunities for both educators and schools, they built a platform that connects educators with schools that align with their values, empowering them to thrive and grow in their careers.",
      founder_des2: "Believing in the transformative power of education, they understand how meaningful connections can have a lasting impact. Through Explore2Teach, they are opening doors to life-changing opportunities, ensuring educators and schools can inspire the next generation together.",
      together: "Together, we will create classrooms that inspire and communities that thrive.",
      areyou: "Are you ready to begin your teaching journey?",
      register: "Register Here"
    },

    es: {
      des: "Explore2Teach es más que una plataforma: es un movimiento. Unimos a educadores de todo el mundo, abriendo puertas a nuevas oportunidades, formación transformadora y una comunidad poderosa. Aquí, los maestros no solo crecen, sino que inspiran, lideran y redefinen el futuro de la educación.",
      mission: "La Misión y Visión de las Fundadoras",
      founder: "Melody y Neriza",
      founder_des: "Impulsadas por su pasión compartida por la educación, Melody y Neriza fundaron Explore2Teach con la visión de ayudar a los educadores a encontrar roles significativos y apoyar a las escuelas en la búsqueda del talento adecuado. Comprometidas a crear oportunidades tanto para educadores como para escuelas, construyeron una plataforma que conecta a los docentes con instituciones que comparten sus valores, permitiéndoles prosperar y crecer en sus carreras.",
      founder_des2: "Creyendo en el poder transformador de la educación, entienden cómo las conexiones significativas pueden tener un impacto duradero. A través de Explore2Teach, están abriendo puertas a oportunidades que cambian vidas, asegurando que educadores y escuelas puedan inspirar juntos a la próxima generación.",
      together: "Juntos, crearemos aulas que inspiren y comunidades que prosperen.",
      areyou: "¿Estás listo para comenzar tu camino docente?",
      register: "Regístrate Aquí"
    }
  },

  explore: {
    en: {
      title: "Explore New Horizons",
      confidence: "with Confidence",
      des: "At Explore2Teach provides essential resources on housing, local communities, financial planning, and more—ensuring a smooth and stress-free transition as you relocate.",
      housing: "Housing Resources",
      relocation: "Relocation Support",
      financial: "Financial Resources",
      community: "Community Resources",
      follow: "Follow us on social media"
    },

    es: {
      title: "Explora Nuevos Horizontes",
      confidence: "con Confianza",
      des: "Explore2Teach ofrece recursos esenciales sobre vivienda, comunidades locales, planificación financiera y más, asegurando una transición fluida y sin estrés mientras te reubicas.",
      housing: "Recursos de Vivienda",
      relocation: "Soporte de Reubicación",
      financial: "Recursos Financieros",
      community: "Recursos Comunitarios",
      follow: "Síguenos en las redes sociales"
    }

  },

  teach: {
    en: {
      title: "Teach with",
      impact: "Impact",
      des: "Explore2Teach offers educators professional development through a resource library, live webinars, and tailored training. We’re here to help you enhance your skills and make a lasting impact in the classroom",
      housing: "Housing Resources",
      res: "Teacher Resources",
      locator: "School Locator",
      cert: "Educator Certification",
      online: "Online Courses",
      follow: "Follow us on social media"
    },

    es: {
      title: "Enseña con",
      impact: "Impacto",
      des: "Explore2Teach ofrece a los educadores desarrollo profesional a través de una biblioteca de recursos, seminarios web en vivo y formación personalizada. Estamos aquí para ayudarte a mejorar tus habilidades y dejar una huella duradera en el aula.",
      housing: "Recursos de Vivienda",
      res: "Recursos para Docentes",
      locator: "Localizador de Escuelas",
      cert: "Certificación para Educadores",
      online: "Cursos en Línea",
      follow: "Síguenos en las redes sociales"
    }

  },
  contact: {
    en: {
      contact_us: "Contact Us",
      home: "Home",
      get_in_touch: "Get In Touch",
      help_text: "We are here for you. How can we help?",
      first_name: "First Name",
      last_name: "Last Name",
      email_address: "Email Address",
      mobile_no: "Mobile No.",
      type_message: "Type Message...",
      submit_now: "Submit Now",
      sending: "Sending...",
      form_note: "Fill out the form and our team will get ",
      form_note2: "back to you within 24 hours.",
      email_us: "Email Us",
      support_text: "Our friendly team is here to help.",
      support_email: "support@explore2teach.com",
      socials: "Our Socials",
      breadcrumb_contact: "Contact Us",
      breadcrumb_home: "Home",
      recaptcha_error: "Please complete the reCAPTCHA.",
      recaptcha_not_ready: "reCAPTCHA is not yet ready. Please try again in a few seconds.",
      message_success: "Message sent successfully!",
      message_fail: "Failed to send message."
    },
    es: {
      contact_us: "Contáctanos",
      home: "Inicio",
      get_in_touch: "Ponte en contacto",
      help_text: "Estamos aquí para ti. ¿Cómo podemos ayudarte?",
      first_name: "Nombre",
      last_name: "Apellido",
      email_address: "Correo Electrónico",
      mobile_no: "Número de Móvil",
      type_message: "Escribe tu mensaje...",
      submit_now: "Enviar Ahora",
      sending: "Enviando...",
      form_note: "Completa el formulario y nuestro equipo",
      form_note2: "te responderemos en 24 horas.",
      email_us: "Envíanos un correo",
      support_text: "Nuestro equipo está aquí para ayudarte.",
      support_email: "support@explore2teach.com",
      socials: "Nuestras Redes Sociales",
      breadcrumb_contact: "Contáctanos",
      breadcrumb_home: "Inicio",
      recaptcha_error: "Por favor completa el reCAPTCHA.",
      recaptcha_not_ready: "El reCAPTCHA aún no está listo. Inténtalo de nuevo en unos segundos.",
      message_success: "¡Mensaje enviado exitosamente!",
      message_fail: "No se pudo enviar el mensaje."
    }


  },
  community: {
    en: {
      title: "Community Resources",
      description: "Relocating to a new state or country presents both exciting opportunities and unique challenges. To support educators transitioning to Florida, we've compiled a list of community resources that can help you connect with local cultural groups, access healthcare services, and participate in volunteer activities.",
      localCommunity: "Local Community",
      healthCenters: "Community Health Centers",
      volunteer: "Volunteer",
      localCommunityTitle: "Local Community",
      localCommunityTitle2: "Organizations",
      pcfiTitle: "Philippine Cultural Foundation, Inc. (PCFI)",
      pcfiDesc: "Based in Tampa, PCFI is a non-profit organization dedicated to preserving and promoting Philippine heritage and culture. They host various events, including the annual PhilFest, which showcases Filipino traditions, cuisine, and arts.",
      projectsEvents: "PROJECTS AND EVENTS",
      bahayTitle: "Bahay Kubo Project",
      bahayDesc: "PCFI's effort to construct a Bahay Kubo (also known as Nipa Hut) at the Philippine Village in Tampa, Florida.",
      barrioTitle: "Barrio Fiesta",
      barrioDesc: "PAAT, in cooperation with PCFI, brings you Barrio Fiesta and Santacruzan at the Bayanihan Arts and Events Center.",
      philfestTitle: "PhilFest",
      philfestDesc: "The biggest Philippine festival in Florida as the PCFI brings you PhilFest every spring.",
      healthServices: "Health Services",
      baycareTitle: "BayCare Community Health",
      baycareDesc: "BayCare offers mobile health services to schools, churches, and community organizations in the Tampa Bay area, including Hillsborough County. They provide health education, screenings, immunizations, and wellness programs.",
      services: "Services",
      screenings: "Health screenings",
      immunizations: "Flu and pneumonia immunizations",
      educationWorkshops: "Health education workshops",
      psychologyTitle: "Psychology House – Mental Healthcare for Teachers",
      psychologyDesc: "Psychology House in Tampa offers mental health services specifically tailored for educators. Recognizing the unique challenges teachers face, they provide counseling and support to help educators maintain their well-being.",
      individualTherapy: "Individual therapy sessions",
      stressManagement: "Stress management",
      burnoutPrevention: "Burnout prevention",
      volunteerTitle1: "Volunteer Opportunities",
      tampaVolunteersTitle: "Tampa Volunteers",
      tampaVolunteersDesc: "Tampa Volunteers is dedicated to building a stronger community through volunteerism. They organize various events throughout the month, supporting causes such as hunger and poverty, environmental conservation, animal welfare, health and disease awareness, children and youth development, and arts and culture.",
      volunteerTitle2: "Volunteer Opportunities"
    },
    es: {
      title: "Recursos comunitarios",
      description: "Mudarse a un nuevo estado o país presenta oportunidades emocionantes y desafíos únicos. Para apoyar a los educadores que se trasladan a Florida, hemos recopilado una lista de recursos comunitarios que pueden ayudarte a conectarte con grupos culturales locales, acceder a servicios de salud y participar en actividades de voluntariado.",
      localCommunity: "Comunidad local",
      healthCenters: "Centros de salud comunitarios",
      volunteer: "Voluntariado",
      localCommunityTitle: "Organizaciones comunitarias",
      localCommunityTitle2: "locales",
      pcfiTitle: "Fundación Cultural Filipina, Inc. (PCFI)",
      pcfiDesc: "Con sede en Tampa, PCFI es una organización sin fines de lucro dedicada a preservar y promover el patrimonio y la cultura filipina. Organizan varios eventos, incluido el PhilFest anual, que muestra las tradiciones, la gastronomía y las artes filipinas.",
      projectsEvents: "PROYECTOS Y EVENTOS",
      bahayTitle: "Proyecto Bahay Kubo",
      bahayDesc: "Esfuerzo de PCFI para construir un Bahay Kubo (también conocido como Nipa Hut) en la Aldea Filipina en Tampa, Florida.",
      barrioTitle: "Barrio Fiesta",
      barrioDesc: "PAAT, en cooperación con PCFI, presenta Barrio Fiesta y Santacruzan en el Bayanihan Arts and Events Center.",
      philfestTitle: "PhilFest",
      philfestDesc: "El festival filipino más grande de Florida, ya que PCFI presenta PhilFest cada primavera.",
      healthServices: "Servicios de salud",
      baycareTitle: "BayCare Salud Comunitaria",
      baycareDesc: "BayCare ofrece servicios de salud móviles a escuelas, iglesias y organizaciones comunitarias en el área de Tampa Bay, incluido el condado de Hillsborough. Proporcionan educación para la salud, exámenes médicos, inmunizaciones y programas de bienestar.",
      services: "Servicios",
      screenings: "Exámenes de salud",
      immunizations: "Vacunas contra la gripe y la neumonía",
      educationWorkshops: "Talleres de educación para la salud",
      psychologyTitle: "Psychology House – Salud mental para docentes",
      psychologyDesc: "Psychology House en Tampa ofrece servicios de salud mental específicamente diseñados para educadores. Reconociendo los desafíos únicos que enfrentan los docentes, brindan asesoramiento y apoyo para ayudarlos a mantener su bienestar.",
      individualTherapy: "Sesiones de terapia individual",
      stressManagement: "Manejo del estrés",
      burnoutPrevention: "Prevención del agotamiento",
      volunteerTitle1: "Oportunidades de voluntariado",
      tampaVolunteersTitle: "Voluntarios de Tampa",
      tampaVolunteersDesc: "Tampa Volunteers está dedicada a construir una comunidad más fuerte a través del voluntariado. Organizan varios eventos a lo largo del mes, apoyando causas como el hambre y la pobreza, la conservación del medio ambiente, el bienestar animal, la concienciación sobre la salud y las enfermedades, el desarrollo de niños y jóvenes, y las artes y la cultura.",
      volunteerTitle2: "Oportunidades de voluntariado"
    }


  },
  financial: {
    en: {
      title1: "Explore the Right ",
      title2: "Financial Options",
      description1: "Explore the right financial options with this curated guide to trusted institutions in Tampa, FL. Find banks, credit unions, and remittance centers near you to manage your finances seamlessly. Whether you need banking services, money transfers, or credit options, this map connects you to financial solutions that support your journey as an educator.",

      section1_title: "US BANKS",
      section1_desc: "Reliable banking institutions offering checking and savings accounts, credit cards, loans, and digital banking services to help teachers manage their finances conveniently.",
      section1_item1: "Personal and business banking, mortgages, and credit solutions.",
      section1_item2: "Full-service banking with online and in-branch support.",
      section1_item3: "Comprehensive financial services, including investment options.",
      section1_item4: "Competitive savings plans and tailored banking services.",
      section1_item5: "Global banking with rewards programs and wealth management.",

      section2_title: "Credit Unions",
      section2_desc: "Member-owned financial institutions that provide lower fees, better interest rates, and personalized financial support for teachers.",
      section2_item1: "Florida’s largest credit union with teacher-friendly banking options.",
      section2_item2: "Affordable banking services, home loans, and insurance options.",
      section2_item3: "Community-focused credit union offering affordable loans.",
      section2_item4: "Competitive mortgage and savings programs.",

      section3_title: "Filipino Banks & ",
      secton3_title2: "Remittance Centers",

      section3_desc: "Specialized financial services that support Filipino teachers with remittance options, Philippine-based banking, and savings solutions tailored for overseas Filipinos.",
      section3_item1: "Secure and efficient money transfers.",
      section3_item2: "Convenient international remittance services.",
      section3_item3: "Fast and reliable money transfer solutions for Filipinos abroad.",

      section4_title: "Remittance & Money",
      section4_title2: "Transfer Services",
      section4_desc: "Trusted platforms that offer fast, secure, and cost-effective ways to send money to family and loved ones in the Philippines.",
      section4_item1: "Global money transfer with cash pickup options.",
      section4_item2: "Low-cost, fast digital remittance with mobile access.",
      section4_item3: "Secure online money transfers with direct deposit options."
    },
    es: {
      title1: "Explora las opciones ",
      title2: "financieras adecuadas",
      description1: "Explora las opciones financieras adecuadas con esta guía de instituciones confiables en Tampa, FL. Encuentra bancos, cooperativas de crédito y centros de remesas cercanos para gestionar tus finanzas sin complicaciones. Ya sea que necesites servicios bancarios, transferencias de dinero u opciones de crédito, este mapa te conecta con soluciones financieras que apoyan tu camino como educador.",

      section1_title: "BANCOS DE EE. UU.",
      section1_desc: "Instituciones bancarias confiables que ofrecen cuentas corrientes y de ahorro, tarjetas de crédito, préstamos y servicios bancarios digitales para ayudar a los maestros a administrar sus finanzas de manera conveniente.",
      section1_item1: "Banca personal y comercial, hipotecas y soluciones de crédito.",
      section1_item2: "Banca de servicio completo con soporte en línea y en sucursal.",
      section1_item3: "Servicios financieros integrales, incluidas opciones de inversión.",
      section1_item4: "Planes de ahorro competitivos y servicios bancarios personalizados.",
      section1_item5: "Banca global con programas de recompensas y gestión patrimonial.",

      section2_title: "Cooperativas de Crédito",
      section2_desc: "Instituciones financieras propiedad de los miembros que ofrecen tarifas más bajas, mejores tasas de interés y apoyo financiero personalizado para los maestros.",
      section2_item1: "La cooperativa de crédito más grande de Florida con opciones bancarias para maestros.",
      section2_item2: "Servicios bancarios asequibles, préstamos hipotecarios y opciones de seguro.",
      section2_item3: "Cooperativa de crédito centrada en la comunidad que ofrece préstamos asequibles.",
      section2_item4: "Programas competitivos de hipotecas y ahorro.",

      section3_title: "Bancos filipinos y ",
      section3_title2: "centros de remesas",
      section3_desc: "Servicios financieros especializados que apoyan a los maestros filipinos con opciones de remesas, banca basada en Filipinas y soluciones de ahorro diseñadas para filipinos en el extranjero.",
      section3_item1: "Transferencias de dinero seguras y eficientes.",
      section3_item2: "Servicios de remesas internacionales convenientes.",
      section3_item3: "Soluciones rápidas y confiables de transferencias de dinero para filipinos en el extranjero.",

      section4_title: "Remesas y servicios ",
      section4_title2: "de transferencia de dinero",
      section4_desc: "Plataformas confiables que ofrecen formas rápidas, seguras y rentables de enviar dinero a la familia y seres queridos en Filipinas.",
      section4_item1: "Transferencia de dinero global con opciones de retiro en efectivo.",
      section4_item2: "Remesas digitales económicas y rápidas con acceso móvil.",
      section4_item3: "Transferencias de dinero en línea seguras con opciones de depósito directo."
    }

  },
  aimatching: {
    en: {
      banner_title: "How Explore2Teach Uses AI to Perfectly Match Educators with Schools",
      intro_paragraph: "In today’s fast-paced world, finding the perfect fit between educators and schools can be a daunting challenge. At Explore2Teach, we leverage cutting-edge AI technology to simplify the process, ensuring that every teacher finds the right environment to connect, empower, and inspire.",

      section1_title: "How Our AI Matching Works",
      section1_subtitle: "Our proprietary algorithm analyzes a wealth of data, including:",
      section1_list1_b: "Educator Profiles:",
      section1_list1_text: " Skills, teaching experience, certifications, and personal preferences.",
      section1_list2_b: "School Needs:",
      section1_list2_text: " Subject requirements, teaching philosophies, and cultural fit.",
      section1_list2_br: "The result? Tailored matches that prioritize long-term success and satisfaction for both educators and schools.",

      section2_title: "Benefits for Teachers",
      section2_paragraph: "With Explore2Teach, teachers save time and energy by eliminating the guesswork. Our system ensures you’re matched with schools that value your skills, align with your goals, and provide opportunities for professional growth.",

      section3_title: "Benefits for Schools",
      section3_paragraph: "Schools gain access to a curated pool of educators whose expertise aligns with their needs, ensuring better retention rates and a more cohesive team.",

      section4_title: "Why Choose Explore2Teach?",
      section4_paragraph: "Our AI matching system doesn’t just pair teachers with schools—it creates opportunities for educators to thrive. By considering every detail, from professional qualifications to personal preferences, we deliver unmatched precision and satisfaction.",

      section5_title: "Your Journey Starts Here",
      section5_paragraph: "Ready to experience the difference? Join Explore2Teach today and discover how our AI-powered matching system can open doors to your dream teaching experience.",

      social: {
        facebook: "https://www.facebook.com/explore2teach/",
        instagram: "https://www.instagram.com/explore2teach/",
        linkedin: "https://linkedin.com/explore2teach"
      }
    },
    es: {
      banner_title: "Cómo Explore2Teach usa la IA para emparejar perfectamente a educadores con escuelas",
      intro_paragraph: "En el mundo acelerado de hoy, encontrar el ajuste perfecto entre educadores y escuelas puede ser un desafío. En Explore2Teach, utilizamos tecnología de IA de vanguardia para simplificar el proceso, asegurando que cada docente encuentre el entorno adecuado para conectar, empoderar e inspirar.",

      section1_title: "Cómo funciona nuestra coincidencia de IA",
      section1_subtitle: "Nuestro algoritmo patentado analiza una gran cantidad de datos, incluyendo:",
      section1_list1_b: "Perfiles de educadores:",
      section1_list1_text: " habilidades, experiencia docente, certificaciones y preferencias personales.",
      section1_list2_b: "Necesidades de la escuela:",
      section1_list2_text: " requisitos de materias, filosofías de enseñanza y compatibilidad cultural.",
      section1_list2_br: "¿El resultado? Coincidencias personalizadas que priorizan el éxito y la satisfacción a largo plazo tanto para los educadores como para las escuelas.",

      section2_title: "Beneficios para los docentes",
      section2_paragraph: "Con Explore2Teach, los docentes ahorran tiempo y energía al eliminar las conjeturas. Nuestro sistema garantiza que te emparejen con escuelas que valoren tus habilidades, se alineen con tus objetivos y ofrezcan oportunidades de crecimiento profesional.",

      section3_title: "Beneficios para las escuelas",
      section3_paragraph: "Las escuelas obtienen acceso a un grupo seleccionado de educadores cuya experiencia se alinea con sus necesidades, asegurando mejores tasas de retención y un equipo más cohesivo.",

      section4_title: "¿Por qué elegir Explore2Teach?",
      section4_paragraph: "Nuestro sistema de coincidencia con IA no solo empareja docentes con escuelas, sino que crea oportunidades para que los educadores prosperen. Al considerar cada detalle, desde las cualificaciones profesionales hasta las preferencias personales, ofrecemos una precisión y satisfacción incomparables.",

      section5_title: "Tu viaje comienza aquí",
      section5_paragraph: "¿Listo para experimentar la diferencia? Únete a Explore2Teach hoy y descubre cómo nuestro sistema de emparejamiento impulsado por IA puede abrirte las puertas a tu experiencia docente ideal.",

      social: {
        facebook: "https://www.facebook.com/explore2teach/",
        instagram: "https://www.instagram.com/explore2teach/",
        linkedin: "https://linkedin.com/explore2teach"
      }
    }
  },

  housing_assistance: {
    en: {
      h1_header: "HOUSING RESOURCES",
      title: "Cultivating a Sense of Home for Educators",
      description: "Housing is one of the most important aspects of relocating to a new country or state. At Explore2Teach, we recognize the ",
      description_br1: "significance of finding a comfortable, secure home. That’s why we’ve designed our housing assistance program to cater",
      description_br2: " to the unique needs of international educators.",
      housing_support_title: "Housing Support for Educators",
      housing_support_text: "Explore2Teach connects educators with reliable property owners, offering affordable housing and expert guidance on rentals, local laws, and utilities for a smooth transition.",
      find_school_button: "Find Your School",
      get_in_touch_button: "GET IN TOUCH",
      strong_start_title: "Building a Strong Start for Your Teaching Journey",
      contact_us_button: "CONTACT US",
      reset_button: "Reset Filter"
    },
    es: {
      h1_header: "RECURSOS DE VIVIENDA",
      title: "Cultivando un Sentido de Hogar para Educadores",
      description: "La vivienda es uno de los aspectos más importantes al mudarse a un nuevo país o estado. En Explore2Teach, reconocemos la ",
      description_br1: "importancia de encontrar un hogar cómodo y seguro. Por eso hemos diseñado nuestro programa de asistencia de vivienda para atender",
      description_br2: " las necesidades únicas de los educadores internacionales.",
      housing_support_title: "Apoyo de Vivienda para Educadores",
      housing_support_text: "Explore2Teach conecta a los educadores con propietarios confiables, ofreciendo viviendas asequibles y orientación experta sobre alquileres, leyes locales y servicios públicos para una transición sin problemas.",
      find_school_button: "Encuentra Tu Escuela",
      get_in_touch_button: "PONTE EN CONTACTO",
      strong_start_title: "Construyendo un Comienzo Sólido para Tu Carrera Docente",
      contact_us_button: "CONTÁCTANOS",
      reset_button: "Restablecer Filtro"
    }


  },
  relocation: {
    en: {
      header_title: "Relocation Support",
      welcoming_title: "Welcoming Nationwide and International Educators",
      welcoming_text: "Relocating to a new country or state is an adventure that comes with its unique set of challenges. At Explore2Teach, we aim to make this journey as seamless and enriching as possible for local and international educators. Our relocation services focus on providing resources and support that help educators integrate into their new communities with confidence and ease.",
      comprehensive_guides_title: "Comprehensive Relocation Guides",
      comprehensive_guides_text: "Navigating a new environment can be daunting, especially when it comes to understanding the practicalities of daily life. To support educators, Explore2Teach offers detailed relocation guides and checklists tailored specifically for local transferring from another state and international teachers.",
      essentials_text: "Step-by-step instructions for establishing utilities, internet, and mobile services.",
      transportation_text: "Information on local transit options, driving regulations, and vehicle registration processes.",
      community_text: "Guidance on participating in local events, joining volunteer groups or social advocacy groups, building professional networks, and accessing safety and support services.",
      quote: "“Explore2Teach: Supporting You,",
      quote2: "Every Step of the Way.”",
      personalized_support_title: "Personalized Support",
      personalized_support_text: "Every educator’s journey is unique. That’s why Explore2Teach provides one-on-one consultations to address individual concerns and ensure a smooth transition.",
      contact_us_button: "CONTACT US"
    },
    es: {
      header_title: "Apoyo para la reubicación",
      welcoming_title: "Dando la bienvenida a educadores nacionales e internacionales",
      welcoming_text: "Mudarse a un nuevo país o estado es una aventura con sus propios desafíos. En Explore2Teach, nuestro objetivo es hacer que este viaje sea lo más fluido y enriquecedor posible para educadores locales e internacionales. Nuestros servicios de reubicación se centran en proporcionar recursos y apoyo que ayuden a los educadores a integrarse en sus nuevas comunidades con confianza y facilidad.",
      comprehensive_guides_title: "Guías de reubicación integrales",
      comprehensive_guides_text: "Navegar en un nuevo entorno puede ser abrumador, especialmente al entender las prácticas cotidianas. Para apoyar a los educadores, Explore2Teach ofrece guías de reubicación detalladas y listas de verificación adaptadas específicamente para docentes locales que se trasladan desde otro estado y maestros internacionales.",
      essentials_text: "Instrucciones paso a paso para establecer servicios de agua, electricidad, internet y móvil.",
      transportation_text: "Información sobre opciones de transporte local, regulaciones de conducción y procesos de registro de vehículos.",
      community_text: "Guía para participar en eventos locales, unirse a grupos de voluntariado o defensa social, construir redes profesionales y acceder a servicios de seguridad y apoyo.",
      quote: "“Explore2Teach: Apoyándote,",
      quote2: "en cada paso del camino.”",
      personalized_support_title: "Apoyo personalizado",
      personalized_support_text: "El viaje de cada educador es único. Por eso Explore2Teach proporciona consultas individuales para abordar preocupaciones específicas y garantizar una transición sin problemas.",
      contact_us_button: "CONTÁCTANOS"
    }
  },

  subscribe: {
    en: {
      header_title: "Unlock Your Teaching Potential",
      header_title_br: "with Explore2Teach",
      header_description: "Explore global and local teaching opportunities, enhance your skills, and make a lasting impact.",
      header_description_br: "Whether you're an international educator or a teacher already in the U.S. looking for your next opportunity, we're here to support your journey.",
      header_button: "Start your next chapter today!",
      form_title: "Subscribe to Us",
      form_first_name: "First Name",
      form_first_name_placeholder: "Enter First Name",
      form_last_name: "Last Name",
      form_last_name_placeholder: "Enter Last Name",
      form_email: "Email",
      form_email_placeholder: "hello@example.com",
      form_contact: "Contact Number",
      form_country: "Country",
      form_country_placeholder: "Select Country",
      form_submit: "Subscribe now",
      form_note: "By submitting, you’ll receive valuable updates and resources to support your global teaching journey.",
      signup_link: "Sign up today to explore exciting teaching opportunities across the U.S. with Explore2Teach!",
      follow_us: "Follow us:"
    },
    es: {
      header_title: "Desbloquea tu potencial docente",
      header_title_br: "con Explore2Teach",
      header_description: "Explora oportunidades de enseñanza globales y locales, mejora tus habilidades y deja una huella duradera.",
      header_description_br: "Ya seas un educador internacional o un maestro que ya está en EE. UU. buscando su próxima oportunidad, estamos aquí para apoyarte en tu viaje.",
      header_button: "¡Comienza tu próximo capítulo hoy!",
      form_title: "Suscríbete a nosotros",
      form_first_name: "Nombre",
      form_first_name_placeholder: "Ingresa tu nombre",
      form_last_name: "Apellido",
      form_last_name_placeholder: "Ingresa tu apellido",
      form_email: "Correo electrónico",
      form_email_placeholder: "correo@ejemplo.com",
      form_contact: "Número de contacto",
      form_country: "País",
      form_country_placeholder: "Selecciona un país",
      form_submit: "Suscribirse ahora",
      form_note: "Al enviar, recibirás valiosas actualizaciones y recursos para apoyar tu trayectoria docente global.",
      signup_link: "¡Regístrate hoy para explorar emocionantes oportunidades de enseñanza en los EE. UU. con Explore2Teach!",
      follow_us: "Síguenos:"
    }
  },
  transportation: {
    en: {
      pageTitle: "Transportation Insights",
      introHeadline: "Navigate your journey with confidence!",
      introDescription: "Explore2Teach offers key transportation insights to help educators navigate local commuting options, public transit routes, and car services for a smooth and stress-free transition. We also provide tips on affordable and convenient travel choices to make daily commutes easier.",
      carRental: "Car Rental",
      publicTransit: "Public Transit",
      bikeScooters: "Bike & Scooters",
      carRentalSectionTitle: "Privately Owned Car Rental Companies in the Tampa Bay Area",
      turoDescription: "Turo is a peer-to-peer car-sharing platform where local hosts offer their personal vehicles for rent. This service allows you to choose from a variety of cars owned by individuals in the Tampa area.",
      getaroundDescription: "Getaround is another car-sharing service that connects renters with private car owners. You can rent cars from locals in Tampa, providing a diverse selection of vehicles.",
      advanceRentDescription: "Serving the Tampa Bay area for over 20 years, Advance Rent A Car is an independent car rental company offering a range of vehicles. They emphasize value, comfort, and customer satisfaction.",
      publicTransitSectionTitle: "Public Transit",
      hartDescription: "HART (Hillsborough Area Regional Transit) – Bus service covering Tampa and surrounding areas, including express routes.",
      tecoDescription: "Free streetcar service connecting downtown Tampa, Channelside, and Ybor City.",
      downtownerDescription: "Free electric shuttle service in downtown Tampa",
      bikeScooterSectionTitle: "Biking & Scooters",
      coastBikeShareTitle: "Coast Bike Share",
      coastBikeShareDescription: "Free streetcar service connecting downtown Tampa, Channelside, and Ybor City.",
      escooterTitle: "E-Scooter",
      escooterDescription: "Lime, Bird, and Spin offer dockless scooters for short-distance travel."
    },
    es: {
      pageTitle: "Información de Transporte",
      introHeadline: "¡Navega tu viaje con confianza!",
      introDescription: "Explore2Teach ofrece información clave de transporte para ayudar a los educadores a navegar las opciones de transporte local, rutas de transporte público y servicios de autos para una transición fluida y sin estrés. También brindamos consejos sobre opciones de viaje económicas y convenientes para facilitar los desplazamientos diarios.",
      carRental: "Alquiler de Autos",
      publicTransit: "Transporte Público",
      bikeScooters: "Bicicletas y Scooters",
      carRentalSectionTitle: "Empresas Privadas de Alquiler de Autos en el Área de Tampa Bay",
      turoDescription: "Turo es una plataforma de autos compartidos entre particulares donde los anfitriones locales ofrecen sus vehículos personales en alquiler. Este servicio le permite elegir entre una variedad de autos propiedad de personas en el área de Tampa.",
      getaroundDescription: "Getaround es otro servicio de autos compartidos que conecta a los arrendatarios con propietarios de autos privados. Puede alquilar autos de personas locales en Tampa, lo que proporciona una selección diversa de vehículos.",
      advanceRentDescription: "Sirviendo al área de Tampa Bay por más de 20 años, Advance Rent A Car es una empresa independiente de alquiler de autos que ofrece una variedad de vehículos. Enfatizan el valor, la comodidad y la satisfacción del cliente.",
      publicTransitSectionTitle: "Transporte Público",
      hartDescription: "HART (Hillsborough Area Regional Transit) – Servicio de autobuses que cubre Tampa y las áreas circundantes, incluidas rutas exprés.",
      tecoDescription: "Servicio gratuito de tranvía que conecta el centro de Tampa, Channelside y Ybor City.",
      downtownerDescription: "Servicio gratuito de transporte eléctrico en el centro de Tampa",
      bikeScooterSectionTitle: "Bicicletas y Scooters",
      coastBikeShareTitle: "Coast Bike Share",
      coastBikeShareDescription: "Servicio gratuito de tranvía que conecta el centro de Tampa, Channelside y Ybor City.",
      escooterTitle: "E-Scooter",
      escooterDescription: "Lime, Bird y Spin ofrecen scooters sin base para viajes de corta distancia."
    }
  },

  essentials: {
    en: {
      header: "How to Set Up Utilities in Your New Home",
      intro: "One of the first things you’ll need to do is set up your essential utilities. From electricity to waste management, Explore2Teach will help you get started quickly and efficiently.",
      categories_electricity: "Electricity",
      categories_water: "Water",
      categories_gas: "Gas",
      categories_garbage: "Garbage Services",
      categories_services: "Services",
      categories_internet: "Internet",
      categories_mobile: "Mobile Services",
      etitle: "Explore2Teach",
      electricitySection_title: "Setting Up Electricity in Florida",
      electricitySection_intro1: "Powering your new home is simple! Electricity service in Florida is provided by a few major utility companies, depending on your location. The most common providers include:",
      electricitySection_intro2: "Explore2Teach",
      electricitySection_intro3: ", we know that setting up electricity in a new home can be confusing, with different providers, regulations, and processes in every location. That’s why we’re here to make it simple!",
      electricitySection_bullets_t1: "Find the Right Provider ",
      electricitySection_bullets_t2: "– We help you understand local electricity markets and choose the best option.",
      electricitySection_bullets_t3: "Step-by-Step Guidance ",
      electricitySection_bullets_t4: "– From applications to meter installations, we walk you through the process.",
      electricitySection_bullets_t5: "Paperwork Made Easy",
      electricitySection_bullets_t6: " – Access templates, connect with local electricians, and ensure compliance.",
      electricitySection_bullets_t7: "Save on Energy Costs",
      electricitySection_bullets_t8: " – Compare plans, avoid hidden fees, and learn smart energy-saving tips.",
      electricitySection_bullets_t9: "Support When You Need It",
      electricitySection_bullets_t10: "– Facing delays or billing issues? We’re here to help troubleshoot.",
      electricitySection_outro: "No matter where you’re moving, ",
      electricitySection_outro2: "Explore2Teach makes getting your electricity set up smooth and stress-free. Let’s get you powered up!",
      waterSection_title: "Setting Up Water Service When Relocating – Let Us Handle the Details!",
      waterSection_intro: "Moving to a new home? Ensuring you have running water from day one is essential. At ",
      waterSection_intro2: "Explore2Teach",
      waterSection_intro3: ", we simplify the setup process so you can focus on settling in.",
      waterSection_bullets_b1: "Find the Right Provider",
      waterSection_bullets_b2: "– We help you navigate local water authorities and private suppliers.",
      waterSection_bullets_b3: "Seamless Registration",
      waterSection_bullets_b4: "– Get step-by-step guidance on applications, meter installations, and transfers.",
      waterSection_bullets_b5: "Paperwork, Simplified ",
      waterSection_bullets_b6: "– We assist with forms, required documents, and compliance checks.",
      waterSection_bullets_b7: "Cost Clarity",
      waterSection_bullets_b8: " – Understand connection fees, deposits, and ways to manage your water bill efficiently.",
      waterSection_bullets_b9: "Support When You Need It ",
      waterSection_bullets_b110: "– Facing delays or billing issues? We’re here to help troubleshoot.",
      waterSection_outro: "No matter where you’re moving, ",
      waterSection_outro2: "ensures your water service is connected smoothly. Let’s get the taps running!",
      gasSection: {
        title: "Effortless Gas Service Setup for Educators – We Handle It All!",
        intro: "Relocating to a new home means juggling many tasks, but setting up your gas service shouldn’t be one of them. At ",
        intro2: ", we simplify the process so you can focus on your work and settle into your new space with ease.",
        bullets: {
          b1: "Find the Right Gas Provider",
          b2: " – We guide you in selecting the best local gas provider, tailored to your needs, whether for heating, cooking, or both.",
          b3: "Handle All Paperwork ",
          b4: "– No need to stress over forms or permits—we’ll take care of all the necessary documentation for you.",
          b5: "Clear Costs ",
          b6: "– We break down any upfront fees, deposits, and billing details, ensuring there are no surprises.",
          b7: "Reliable Assistance Anytime ",
          b8: "– If you face any issues, from pressure fluctuations to leaks or delays, we’re here to provide timely troubleshooting and expert solutions."
        },
        outro: "Wherever you're moving, ",
        outro2: "ensures your gas service setup is hassle-free, so you can focus on teaching and enjoy your new home without the stress."
      },
      garbageSection: {
        title: "Stress-Free Solid Waste Setup for Your New Home – We’ve Got Your Back, Educators!",
        bullets: {
          b1: "Connect with the Best Providers",
          b2: " – We help you find reliable local waste management services, so you can rest assured your trash will be handled.",
          b3: "Simple, Fast Setup",
          b4: "– From registration to scheduling pickups, we ensure the process is hassle-free and efficient.",
          b5: "Recycling Made Easy",
          b6: "– We walk you through the recycling guidelines in your new area, helping you stay eco-conscious and compliant.",
          b7: "Ongoing Support",
          b8: "– Missed pickups or unique disposal needs? We’re always here to offer quick solutions and keep things running smoothly.",
        },
        outro: "Wherever you're moving, ",
        outro2: " ensures your waste management setup is smooth and stress-free"
      },
      internetSection: {
        title: "Effortless Internet Setup for Your New Home",
        intro: "Moving to a new home brings a lot of changes, but setting up your internet service doesn’t have to add to the stress. At Explore2Teach, we make sure your internet is up and running smoothly so you can focus on what matters most—teaching—right from the start.",
        bullets: {
          b1: "Explore Top Internet Options",
          b2: " – We help teachers like you navigate the best local internet providers, ensuring fast and reliable coverage for all your needs.",
          b3: "Customized Plan Recommendations",
          b4: " – Whether you need high-speed for virtual classes, grading, or personal use, we guide you to the perfect plan.",
          b5: "Fast & Easy Installation",
          b6: " – From scheduling installation to setting up your tech, we ensure everything is ready quickly so you can focus on teaching.",
          b7: "Ongoing Support",
          b8: " – Technical issues or billing concerns? We're here to provide solutions and keep your connection seamless.",
        }
      },
      mobileSection: {
        title: "Streamlined Mobile Service Setup for Educators – Simplifying Your Move!",
        intro: "At ",
        intro2: " we simplify mobile service setup for educators, ensuring you stay connected without the hassle.",
        bullets: {
          b1: "Unlock the Best Mobile Options for Educators",
          b2: " – We help you find the best mobile providers in your area for reliable coverage.",
          b3: "Plan Recommendations",
          b4: " – Choose the perfect plan based on your teaching and personal needs.",
          b5: "Seamless Activation",
          b6: " – We handle everything from number transfers to device setup.",
          b7: "Transparent Pricing",
          b8: " – Know all costs upfront, with no hidden fees.",
          b9: "Continuous Assistance",
          b10: " – From coverage issues to billing inquiries, we’re here to support you every step of the way.",

        },
        outro: "Let ",
        outro2: "make your mobile setup easy, so you can focus on what matters—teaching!"
      }
    },
    es: {
      header: "Cómo Configurar los Servicios Básicos en Tu Nuevo Hogar",
      intro: "Una de las primeras cosas que necesitarás hacer es configurar tus servicios esenciales. Desde electricidad hasta la gestión de residuos, Explore2Teach te ayudará a empezar de manera rápida y eficiente.",
      categories_electricity: "Electricidad",
      categories_water: "Agua",
      categories_gas: "Gas",
      categories_garbage: "Servicios de Basura",
      categories_services: "Servicios",
      categories_internet: "Internet",
      categories_mobile: "Servicios Móviles",
      etitle: "Explore2Teach",
      electricitySection_title: "Configuración de Electricidad al Reubicarse – ¡Nosotros te Ayudamos!",
      electricitySection_intro1: "En ",
      electricitySection_intro2: "Explore2Teach",
      electricitySection_intro3: ", sabemos que configurar la electricidad en un nuevo hogar puede ser confuso, con diferentes proveedores, normativas y procesos en cada lugar. ¡Por eso estamos aquí para hacerlo simple!",
      electricitySection_bullets_t1: "Encuentra al Proveedor Adecuado ",
      electricitySection_bullets_t2: "– Te ayudamos a entender el mercado eléctrico local y elegir la mejor opción.",
      electricitySection_bullets_t3: "Guía Paso a Paso ",
      electricitySection_bullets_t4: "– Desde las solicitudes hasta la instalación de medidores, te acompañamos en todo el proceso.",
      electricitySection_bullets_t5: "Trámites Simplificados",
      electricitySection_bullets_t6: " – Accede a plantillas, conecta con electricistas locales y asegura el cumplimiento.",
      electricitySection_bullets_t7: "Ahorra en Costos de Energía",
      electricitySection_bullets_t8: " – Compara planes, evita cargos ocultos y aprende consejos para ahorrar energía.",
      electricitySection_bullets_t9: "Soporte Cuando lo Necesites",
      electricitySection_bullets_t10: "– ¿Problemas con facturas o demoras? Estamos aquí para ayudarte.",
      electricitySection_outro: "No importa a dónde te mudes, ",
      electricitySection_outro2: "Explore2Teach hace que la configuración de tu electricidad sea fluida y sin estrés. ¡Vamos a conectarte!",
      waterSection_title: "Configuración de Agua al Reubicarse – ¡Nosotros nos Encargamos!",
      waterSection_intro: "¿Te mudas a un nuevo hogar? Asegurarte de tener agua desde el primer día es esencial. En ",
      waterSection_intro2: "Explore2Teach",
      waterSection_intro3: ", simplificamos el proceso para que puedas concentrarte en instalarte.",
      waterSection_bullets_b1: "Encuentra al Proveedor Adecuado",
      waterSection_bullets_b2: "– Te ayudamos a navegar por las autoridades locales de agua y proveedores privados.",
      waterSection_bullets_b3: "Registro Sin Complicaciones",
      waterSection_bullets_b4: "– Obtén orientación paso a paso sobre solicitudes, instalaciones de medidores y transferencias.",
      waterSection_bullets_b5: "Trámites Simplificados ",
      waterSection_bullets_b6: "– Te asistimos con formularios, documentos requeridos y verificaciones de cumplimiento.",
      waterSection_bullets_b7: "Costos Claros",
      waterSection_bullets_b8: " – Entiende las tarifas de conexión, depósitos y cómo gestionar tu factura de agua de manera eficiente.",
      waterSection_bullets_b9: "Soporte Cuando lo Necesites ",
      waterSection_bullets_b110: "– ¿Problemas con retrasos o facturación? Estamos aquí para ayudarte.",
      waterSection_outro: "No importa a dónde te mudes, ",
      waterSection_outro2: "nos aseguramos de que tu servicio de agua esté conectado sin problemas. ¡Abramos el grifo!",
      gasSection: {
        title: "Configuración de Gas Sin Complicaciones para Educadores – ¡Nosotros lo Hacemos Todo!",
        intro: "Mudarte a un nuevo hogar implica muchas tareas, pero configurar tu servicio de gas no debería ser una de ellas. En ",
        intro2: ", simplificamos el proceso para que puedas concentrarte en tu trabajo y adaptarte a tu nuevo hogar sin problemas.",
        bullets: {
          b1: "Encuentra al Proveedor de Gas Adecuado",
          b2: " – Te guiamos para seleccionar el mejor proveedor local de gas, ya sea para calefacción, cocina o ambos.",
          b3: "Nos Encargamos de los Trámites ",
          b4: "– No te preocupes por formularios o permisos—nosotros nos encargamos de toda la documentación necesaria.",
          b5: "Costos Claros ",
          b6: "– Desglosamos las tarifas iniciales, depósitos y detalles de facturación para que no haya sorpresas.",
          b7: "Asistencia Confiable en Todo Momento ",
          b8: "– ¿Problemas como fugas, fluctuaciones de presión o demoras? Estamos aquí para brindarte soluciones rápidas y expertas."
        },
        outro: "A donde sea que te mudes, ",
        outro2: "nos aseguramos de que la configuración de tu servicio de gas sea sin estrés, para que puedas centrarte en la enseñanza y disfrutar de tu nuevo hogar."
      },
      garbageSection: {
        title: "Configuración Sin Estrés de Servicios de Basura – ¡Apoyo Total para Educadores!",
        bullets: {
          b1: "Conéctate con los Mejores Proveedores",
          b2: " – Te ayudamos a encontrar servicios de gestión de residuos confiables en tu nueva área.",
          b3: "Configuración Rápida y Sencilla",
          b4: "– Desde el registro hasta la programación de recolecciones, hacemos que el proceso sea eficiente y sin complicaciones.",
          b5: "Reciclaje Fácil",
          b6: "– Te guiamos en las normas de reciclaje locales para que puedas mantenerte ecológico y en cumplimiento.",
          b7: "Soporte Continuo",
          b8: "– ¿Recolecciones perdidas o necesidades especiales de eliminación? Siempre estamos aquí para ofrecer soluciones rápidas y mantener todo funcionando sin problemas."
        },
        outro: "A donde sea que te mudes, ",
        outro2: "nos aseguramos de que tu servicio de gestión de residuos sea fluido y sin estrés"
      },
      internetSection: {
        title: "Configuración de Internet Sin Complicaciones en Tu Nuevo Hogar",
        intro: "Mudarte a un nuevo hogar trae muchos cambios, pero configurar tu servicio de internet no tiene por qué ser uno de ellos. En Explore2Teach, nos aseguramos de que tu conexión esté lista para que puedas concentrarte en lo más importante: enseñar, desde el primer día.",
        bullets: {
          b1: "Explora las Mejores Opciones de Internet",
          b2: " – Ayudamos a docentes como tú a encontrar los mejores proveedores locales, asegurando cobertura rápida y confiable.",
          b3: "Planes Personalizados",
          b4: " – Ya sea que necesites alta velocidad para clases virtuales, calificar trabajos o uso personal, te guiamos al plan ideal.",
          b5: "Instalación Rápida y Sencilla",
          b6: " – Desde la programación hasta la configuración, nos aseguramos de que todo esté listo rápidamente para que puedas enfocarte en enseñar.",
          b7: "Soporte Continuo",
          b8: " – ¿Problemas técnicos o con la facturación? Estamos aquí para brindarte soluciones y mantener tu conexión estable."
        }
      },
      mobileSection: {
        title: "Configuración de Servicios Móviles Sin Complicaciones para Educadores – ¡Facilitamos tu Mudanza!",
        intro: "En ",
        intro2: " simplificamos la configuración del servicio móvil para educadores, asegurando que te mantengas conectado sin complicaciones.",
        bullets: {
          b1: "Descubre las Mejores Opciones Móviles para Educadores",
          b2: " – Te ayudamos a encontrar los mejores proveedores móviles en tu área con cobertura confiable.",
          b3: "Planes Personalizados",
          b4: " – Elige el plan perfecto según tus necesidades docentes y personales.",
          b5: "Activación Sin Complicaciones",
          b6: " – Nos encargamos de todo, desde transferencias de número hasta la configuración de tu dispositivo.",
          b7: "Precios Transparentes",
          b8: " – Conoce todos los costos de antemano, sin tarifas ocultas.",
          b9: "Asistencia Continua",
          b10: " – Desde problemas de cobertura hasta consultas de facturación, estamos aquí para apoyarte en cada paso."
        },
        outro: "Deja que ",
        outro2: "haga fácil tu configuración móvil, ¡así podrás concentrarte en lo que más importa—enseñar!"
      }
    }
  },

  teacher_resource: {
    en: {
      banner_header: "Explore Teaching Resources",
      banner_subtext: "Discover a curated collection of tools and materials to support every aspect of your teaching journey.",
      banner_paragraph: "From classroom management strategies to customizable lesson plan templates, professional development webinars, and technology integration guides, these resources are designed to save you time, enhance your skills, and empower your teaching experience.",
      section_title: "Empowering Teachers, Enriching Classrooms",
      contact_button: "Contact Us"
    },
    es: {
      banner_header: "Explora Recursos Educativos",
      banner_subtext: "Descubre una colección seleccionada de herramientas y materiales para apoyar cada aspecto de tu labor docente.",
      banner_paragraph: "Desde estrategias de gestión del aula hasta plantillas personalizables de planes de lecciones, seminarios web de desarrollo profesional y guías para la integración tecnológica, estos recursos están diseñados para ahorrarte tiempo, mejorar tus habilidades y fortalecer tu experiencia docente.",
      section_title: "Empoderando a los Docentes, Enriqueciendo las Aulas",
      contact_button: "Contáctanos"
    }

  },

  teacher_template_modal: {
    en: {
      modal_title: "Teacher Templates",
      modal_intro: "Here you can access/download various templates for teachers.",
      modal_subtext: "You can click to download",
      template_1: "Florida Department of Education - ESOL Lesson Plan Template",
      template_2: "Lecture Notes Template",
      template_3: "Lesson Plan Template for Instructors using the FDOE Adult ESOL Framework",
      modal_close_button: "Close"
    },
    es: {
      modal_title: "Plantillas para Docentes",
      modal_intro: "Aquí puedes acceder/descargar varias plantillas para docentes.",
      modal_subtext: "Haz clic para descargar",
      template_1: "Departamento de Educación de Florida - Plantilla de Plan de Lección ESOL",
      template_2: "Plantilla de Apuntes de Clase",
      template_3: "Plantilla de Plan de Lección para Instructores usando el Marco de ESOL para Adultos de FDOE",
      modal_close_button: "Cerrar"
    }


  },

  smart_tools: {
    en: {
      modal_title: "Smart Tools & Guides",
      modal_intro: "Here you can access various tools for teachers.",
      tool_1_title: "Kahoot!",
      tool_1_desc: "Best practices for creating engaging quizzes and assessments",
      tool_2_title: "Quizziz",
      tool_2_desc: "Guides for using Quizziz for gamified learning and assessment",
      tool_3_title: "Canva for Education Teacher Hub",
      tool_3_desc: "Training on designing engaging lesson materials with Canva",
      tool_4_title: "Zoom Educator Training",
      tool_4_desc: "Guides using Zoom for virtual classrooms and online teaching",
      modal_close_button: "Close"
    },
    es: {
      modal_title: "Herramientas Inteligentes y Guías",
      modal_intro: "Aquí puedes acceder a varias herramientas para docentes.",
      tool_1_title: "Kahoot!",
      tool_1_desc: "Mejores prácticas para crear cuestionarios y evaluaciones atractivas",
      tool_2_title: "Quizziz",
      tool_2_desc: "Guías para usar Quizziz en aprendizaje y evaluación gamificada",
      tool_3_title: "Canva para Educación",
      tool_3_desc: "Capacitación para diseñar materiales de lecciones atractivas con Canva",
      tool_4_title: "Capacitación de Zoom para Educadores",
      tool_4_desc: "Guías para usar Zoom en clases virtuales y enseñanza online",
      modal_close_button: "Cerrar"
    }


  },


  class_room: {
    en: {
      page_title: "Classroom Management",
      intro_paragraph: "A well-managed classroom fosters engagement, respect, and a positive learning environment. These expert insights provide teachers with practical strategies to establish clear expectations, maintain structure, and build meaningful connections with students. Explore thought-provoking TED Talks on what makes educators truly effective.",
      watch_button: "WATCH NOW",
      modal_title: "Watch Video"
    },
    es: {
      page_title: "Gestión del Aula",
      intro_paragraph: "Un aula bien gestionada fomenta la participación, el respeto y un entorno de aprendizaje positivo. Estas ideas de expertos brindan a los docentes estrategias prácticas para establecer expectativas claras, mantener la estructura y construir conexiones significativas con los estudiantes. Explora inspiradoras charlas TED sobre lo que hace verdaderamente efectivos a los educadores.",
      watch_button: "VER AHORA",
      modal_title: "Ver Video"
    }
  },

  online_course: {
    en: {
      page_heading: "Learn. Grow. Inspire.",
      intro_paragraph: "Whether you're looking to refine your teaching strategies, explore innovative educational tools, or gain insights into global best practices, you'll find valuable learning opportunities here.",
      section_title: "Online Courses",
      course_1: "Personal and business banking, mortgages, and credit solutions.",
      course_2: "Free courses on online teaching, including Google Classroom, virtual classrooms, and open educational resources.",
      course_3: "Offers courses like 'Global Education for Teachers' and 'Reflective Practice in Teaching'.",
      course_4: "TeachersFirst - OK2Ask® offers free online workshops with practical teaching strategies. Access live or on-demand sessions—no sign-up needed!"
    },
    es: {
      page_heading: "Aprende. Crece. Inspira.",
      intro_paragraph: "Ya sea que busques perfeccionar tus estrategias de enseñanza, explorar herramientas educativas innovadoras o conocer mejores prácticas globales, aquí encontrarás valiosas oportunidades de aprendizaje.",
      section_title: "Cursos en Línea",
      course_1: "Servicios bancarios personales y comerciales, hipotecas y soluciones de crédito.",
      course_2: "Cursos gratuitos sobre enseñanza en línea, incluyendo Google Classroom, aulas virtuales y recursos educativos abiertos.",
      course_3: "Ofrece cursos como 'Educación Global para Docentes' y 'Práctica Reflexiva en la Enseñanza'.",
      course_4: "TeachersFirst - OK2Ask® ofrece talleres en línea gratuitos con estrategias prácticas de enseñanza. Accede a sesiones en vivo o bajo demanda—¡sin necesidad de registro!"
    }
  },

  disclaimer: {
    en: {
      page_title: "Disclaimer for Explore2Teach",
      last_updated: "Last Updated: March 11, 2025",
      section_1_title: "1. General Disclaimer",
      section_1_p1: "Explore2Teach provides information, resources, and services to connect educators with schools. While we strive for accuracy, all information on our website and communications is provided “as is” without warranties of any kind, either express or implied. Users should verify all information independently before making decisions.",
      section_1_p2: "We make no representations or warranties regarding the accuracy or completeness of our content and assume no liability for any reliance on the information provided.",
      section_2_title: "2. No Guarantee of Employment",
      section_2_p1: "Explore2Teach does not guarantee employment, visa approvals, or placement outcomes. Job offers and approvals are subject to employer discretion, visa regulations, and compliance with applicable laws.",
      section_3_title: "3. Third-Party Links & Services",
      section_3_p1: "Our platform may contain links to third-party websites or services. We do not control or take responsibility for the content, privacy policies, or practices of these third-party entities.",
      section_4_title: "4. Legal & Financial Advice Disclaimer",
      section_4_p1: "The content provided by Explore2Teach does not constitute legal, financial, or professional advice. Users should consult with relevant experts for guidance on visa applications, employment contracts, and financial decisions.",
      section_5_title: "5. Limitation of Liability",
      section_5_p1: "Explore2Teach, its partners, and affiliates shall not be liable for any direct, indirect, incidental, or consequential damages arising from:",
      section_5_list_1: "The use of our platform or services.",
      section_5_list_2: "Misinterpretation of information provided.",
      section_5_list_3: "Delays, errors, or disruptions in service.",
      section_6_title: "6. Modifications & Updates",
      section_6_p1: "Explore2Teach reserves the right to update, modify, or discontinue any aspect of its services, policies, or content without prior notice.",
      section_7_title: "7. Contact Information",
      section_7_p1: "For inquiries regarding this Disclaimer, contact us at:",
      contact_email: "📧 support@explore2teach.com"
    },
    es: {
      page_title: "Descargo de Responsabilidad para Explore2Teach",
      last_updated: "Última actualización: 11 de marzo de 2025",
      section_1_title: "1. Descargo de Responsabilidad General",
      section_1_p1: "Explore2Teach proporciona información, recursos y servicios para conectar a educadores con escuelas. Aunque nos esforzamos por ser precisos, toda la información en nuestro sitio web y comunicaciones se proporciona “tal como está” sin garantías de ningún tipo, ya sean expresas o implícitas. Los usuarios deben verificar toda la información de manera independiente antes de tomar decisiones.",
      section_1_p2: "No hacemos declaraciones ni garantías sobre la precisión o integridad de nuestro contenido y no asumimos ninguna responsabilidad por cualquier confianza depositada en la información proporcionada.",
      section_2_title: "2. No Garantía de Empleo",
      section_2_p1: "Explore2Teach no garantiza empleo, aprobaciones de visas ni resultados de colocación. Las ofertas de trabajo y aprobaciones están sujetas a la discreción del empleador, regulaciones de visas y cumplimiento de las leyes aplicables.",
      section_3_title: "3. Enlaces y Servicios de Terceros",
      section_3_p1: "Nuestra plataforma puede contener enlaces a sitios web o servicios de terceros. No controlamos ni nos hacemos responsables del contenido, las políticas de privacidad o las prácticas de estas entidades de terceros.",
      section_4_title: "4. Descargo de Responsabilidad Legal y Financiera",
      section_4_p1: "El contenido proporcionado por Explore2Teach no constituye asesoramiento legal, financiero o profesional. Los usuarios deben consultar con expertos relevantes para obtener orientación sobre solicitudes de visa, contratos de trabajo y decisiones financieras.",
      section_5_title: "5. Limitación de Responsabilidad",
      section_5_p1: "Explore2Teach, sus socios y afiliados no serán responsables de ningún daño directo, indirecto, incidental o consecuente derivado de:",
      section_5_list_1: "El uso de nuestra plataforma o servicios.",
      section_5_list_2: "Mala interpretación de la información proporcionada.",
      section_5_list_3: "Retrasos, errores o interrupciones en el servicio.",
      section_6_title: "6. Modificaciones y Actualizaciones",
      section_6_p1: "Explore2Teach se reserva el derecho de actualizar, modificar o descontinuar cualquier aspecto de sus servicios, políticas o contenido sin previo aviso.",
      section_7_title: "7. Información de Contacto",
      section_7_p1: "Para consultas sobre este Descargo de Responsabilidad, contáctenos en:",
      contact_email: "📧 support@explore2teach.com"
    }
  },

  privacy_policy: {
    en: {
      page_title: "Privacy Policy for Explore2Teach",
      effective_date: "Effective Date: January 24, 2025",
      last_updated: "Last Updated: March 11, 2025",
      intro_p1: "Explore2Teach (\"we,\" \"our,\" or \"us\") is committed to protecting the privacy of educators, schools, and partners who use our platform. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website, www.explore2teach.com, and engage with our services.",
      intro_p2: "By accessing Explore2Teach, you agree to this Privacy Policy. If you do not agree, please do not use our services.",
      section_1_title: "1. Information We Collect",
      section_1_p1: "We collect personal and non-personal information, including but not limited to:",
      section_1_list_1: "Personal Information: Name, email address, phone number, location, nationality, educational background, work experience, teaching certifications, and other application details.",
      section_1_list_2: "School and Employer Information: School name, location, hiring preferences, and other recruitment-related data.",
      section_1_list_3: "Technical Information: IP address, browser type, device information, and cookies for analytics and security.",
      section_1_list_4: "Financial Information (if applicable): Payment details for service subscriptions, background checks, or visa processing assistance.",
      section_2_title: "2. How We Use Your Information",
      section_2_p1: "We use your information for the following purposes:",
      section_2_list_1: "To provide our services, including educator recruitment, job matching, and application processing.",
      section_2_list_2: "To verify credentials and eligibility for teaching opportunities.",
      section_2_list_3: "To communicate with users regarding applications, job offers, and onboarding processes.",
      section_2_list_4: "To enhance user experience through website improvements, data analytics, and technical support.",
      section_2_list_5: "To comply with legal and regulatory requirements.",
      section_3_title: "3. Information Sharing & Disclosure",
      section_3_p1: "We do not sell, rent, or trade your personal information. However, we may share your data with:",
      section_3_list_1: "Partner Schools & Employers: To facilitate job placements and hiring processes.",
      section_3_list_2: "Third-Party Service Providers: For background checks, credential verifications, or technical support.",
      section_3_list_3: "Other Service Providers: Third-party vendors who assist with business operations (e.g. website hosting, analytics, and payment processing). These vendors are required to protect your data and use it only for the purposes for which we disclose it.",
      section_3_list_4: "Legal Authorities: If required by law or in response to valid legal requests.",
      section_4_title: "4. Data Security",
      section_4_p1: "We implement industry-standard security measures to protect your data from unauthorized access, alteration, or disclosure. However, no method of data transmission over the internet is 100% secure, so we cannot guarantee absolute security.",
      section_5_title: "5. User Rights & Choices",
      section_5_p1: "Depending on your location and applicable laws, you have the right to:",
      section_5_list_1: "Access, update, or correct your personal information.",
      section_5_list_2: "Request deletion of your account and associated data.",
      section_5_list_3: "Opt-out of marketing emails by following the \"unsubscribe\" link in emails.",
      section_6_title: "6. Third Party Links",
      section_6_p1: "Our website may contain links to external sites not operated by us. We are not responsible for the content or privacy practices of these third-party sites. We encourage you to review their privacy policies before providing any personal information.",
      section_7_title: "7. Cookies & Tracking Technologies",
      section_7_p1: "Our website may use cookies to improve functionality and user experience. You can manage cookie settings through your browser.",
      section_8_title: "8. Changes to This Privacy Policy",
      section_8_p1: "We may update this Privacy Policy periodically. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.",
      section_9_title: "9. Contact Information",
      section_9_p1: "If you have questions about this Privacy Policy, contact us at:",
      contact_email: "📧 support@explore2teach.com"
    },
    es: {
      page_title: "Política de Privacidad de Explore2Teach",
      effective_date: "Fecha de entrada en vigor: 24 de enero de 2025",
      last_updated: "Última actualización: 11 de marzo de 2025",
      intro_p1: "Explore2Teach (\"nosotros,\" \"nuestro,\" o \"nos\") se compromete a proteger la privacidad de educadores, escuelas y socios que utilizan nuestra plataforma. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos su información cuando visita nuestro sitio web, www.explore2teach.com, y utiliza nuestros servicios.",
      intro_p2: "Al acceder a Explore2Teach, usted acepta esta Política de Privacidad. Si no está de acuerdo, por favor no utilice nuestros servicios.",
      section_1_title: "1. Información que Recopilamos",
      section_1_p1: "Recopilamos información personal y no personal, incluyendo pero no limitado a:",
      section_1_list_1: "Información Personal: Nombre, correo electrónico, número de teléfono, ubicación, nacionalidad, formación académica, experiencia laboral, certificaciones docentes y otros detalles de la solicitud.",
      section_1_list_2: "Información de Escuelas y Empleadores: Nombre de la escuela, ubicación, preferencias de contratación y otros datos relacionados con la contratación.",
      section_1_list_3: "Información Técnica: Dirección IP, tipo de navegador, información del dispositivo y cookies para análisis y seguridad.",
      section_1_list_4: "Información Financiera (si corresponde): Datos de pago para suscripciones de servicios, verificaciones de antecedentes o asistencia con procesos de visa.",
      section_2_title: "2. Cómo Usamos su Información",
      section_2_p1: "Usamos su información para los siguientes fines:",
      section_2_list_1: "Proporcionar nuestros servicios, incluyendo la contratación de educadores, emparejamiento de empleos y procesamiento de solicitudes.",
      section_2_list_2: "Verificar credenciales y elegibilidad para oportunidades de enseñanza.",
      section_2_list_3: "Comunicarnos con los usuarios sobre solicitudes, ofertas de trabajo y procesos de incorporación.",
      section_2_list_4: "Mejorar la experiencia del usuario mediante mejoras en el sitio web, análisis de datos y soporte técnico.",
      section_2_list_5: "Cumplir con requisitos legales y normativos.",
      section_3_title: "3. Compartir y Divulgar Información",
      section_3_p1: "No vendemos, alquilamos ni comercializamos su información personal. Sin embargo, podemos compartir sus datos con:",
      section_3_list_1: "Escuelas y Empleadores Asociados: Para facilitar la colocación laboral y los procesos de contratación.",
      section_3_list_2: "Proveedores de Servicios de Terceros: Para verificaciones de antecedentes, verificaciones de credenciales o soporte técnico.",
      section_3_list_3: "Otros Proveedores de Servicios: Proveedores externos que ayudan en las operaciones comerciales (por ejemplo, alojamiento de sitios web, análisis y procesamiento de pagos). Estos proveedores están obligados a proteger sus datos y utilizarlos solo para los fines para los que se los proporcionamos.",
      section_3_list_4: "Autoridades Legales: Si es requerido por ley o en respuesta a solicitudes legales válidas.",
      section_4_title: "4. Seguridad de los Datos",
      section_4_p1: "Implementamos medidas de seguridad estándar de la industria para proteger sus datos contra el acceso no autorizado, la alteración o la divulgación. Sin embargo, ningún método de transmisión de datos a través de internet es 100% seguro, por lo que no podemos garantizar una seguridad absoluta.",
      section_5_title: "5. Derechos y Opciones del Usuario",
      section_5_p1: "Dependiendo de su ubicación y las leyes aplicables, usted tiene derecho a:",
      section_5_list_1: "Acceder, actualizar o corregir su información personal.",
      section_5_list_2: "Solicitar la eliminación de su cuenta y los datos asociados.",
      section_5_list_3: "Cancelar la suscripción a correos electrónicos de marketing siguiendo el enlace de \"cancelar suscripción\" en los correos electrónicos.",
      section_6_title: "6. Enlaces de Terceros",
      section_6_p1: "Nuestro sitio web puede contener enlaces a sitios externos no operados por nosotros. No somos responsables del contenido o las prácticas de privacidad de estos sitios de terceros. Le recomendamos que revise sus políticas de privacidad antes de proporcionar cualquier información personal.",
      section_7_title: "7. Cookies y Tecnologías de Seguimiento",
      section_7_p1: "Nuestro sitio web puede utilizar cookies para mejorar la funcionalidad y la experiencia del usuario. Puede administrar la configuración de cookies a través de su navegador.",
      section_8_title: "8. Cambios en Esta Política de Privacidad",
      section_8_p1: "Podemos actualizar esta Política de Privacidad periódicamente. Cualquier cambio se publicará en esta página con una fecha de entrada en vigor actualizada. Le recomendamos revisar esta política periódicamente.",
      section_9_title: "9. Información de Contacto",
      section_9_p1: "Si tiene preguntas sobre esta Política de Privacidad, contáctenos en:",
      contact_email: "📧 support@explore2teach.com"
    }
  },

  user_login: {
    en: {
      login_as_teacher: "Login as Teacher",
      login_as_school: "Login as School",
      sign_in_title: "Sign in to your account",
      email_label: "Email",
      email_placeholder: "Enter email",
      password_label: "Password",
      password_placeholder: "Enter password",
      forgot_password: "Forgot your password?",
      sign_in_button: "Sign In",
      no_account: "Don't have an account?",
      sign_up: "Sign up"
    },
    es: {
      login_as_teacher: "Iniciar sesión como profesor",
      login_as_school: "Iniciar sesión como escuela",
      sign_in_title: "Inicia sesión en tu cuenta",
      email_label: "Correo electrónico",
      email_placeholder: "Introduce tu correo electrónico",
      password_label: "Contraseña",
      password_placeholder: "Introduce tu contraseña",
      forgot_password: "¿Olvidaste tu contraseña?",
      sign_in_button: "Iniciar sesión",
      no_account: "¿No tienes una cuenta?",
      sign_up: "Regístrate"
    }
  },

  user_register: {
    en: {
      sign_up_title: "Sign up",
      first_name_label: "First Name",
      first_name_placeholder: "Enter First Name",
      last_name_label: "Last Name",
      last_name_placeholder: "Enter Last Name",
      email_label: "Email",
      email_placeholder: "hello@example.com",
      contact_number_label: "Contact Number",
      country_label: "Country",
      country_placeholder: "Select Country",
      password_label: "Password",
      loading: "Loading...",
      sign_up_button: "Sign up",
      disclaimer: "By submitting, you’ll receive valuable updates and resources to support your global teaching journey.",
      already_account: "Already have an account? Sign in here",
      signup_cta: "Sign up today to explore exciting teaching opportunities across the U.S. with Explore2Teach!",
      follow_us: "Follow us:"
    },
    es: {
      sign_up_title: "Regístrate",
      first_name_label: "Nombre",
      first_name_placeholder: "Introduce tu nombre",
      last_name_label: "Apellido",
      last_name_placeholder: "Introduce tu apellido",
      email_label: "Correo electrónico",
      email_placeholder: "correo@ejemplo.com",
      contact_number_label: "Número de contacto",
      country_label: "País",
      country_placeholder: "Selecciona un país",
      password_label: "Contraseña",
      loading: "Cargando...",
      sign_up_button: "Regístrate",
      disclaimer: "Al enviar, recibirás actualizaciones y recursos valiosos para apoyar tu viaje de enseñanza global.",
      already_account: "¿Ya tienes una cuenta? Inicia sesión aquí",
      signup_cta: "¡Regístrate hoy para explorar emocionantes oportunidades de enseñanza en los EE. UU. con Explore2Teach!",
      follow_us: "Síguenos:"
    }
  },
  user_profile: {
    en: {
      profile_strength: "Profile Strength",
      update_resume: "Update Resume",
      upload_resume: "Upload Resume",
      update_presentation_video: "Update Presentation Video",
      upload_presentation_video: "Upload Presentation Video",
      update_lesson_plan: "Update Lesson Plan",
      upload_lesson_plan: "Upload Lesson Plan",
      update_certifications: "Update Certifications",
      upload_certifications: "Upload Certifications",
      update_recent_evaluation: "Update Recent Evaluation",
      upload_recent_evaluation: "Upload Recent Evaluation",
      update_references: "Update References",
      upload_references: "Upload References",
      profile_details: "Profile Details",
      first_name: "First Name*",
      last_name: "Last Name*",
      email_address: "Email Address*",
      contact_number: "Contact Number*",
      gender: "Gender",
      select_gender: "Select Gender",
      male: "Male",
      female: "Female",
      any: "Any",
      date_of_birth: "Date of birth",
      address: "Address*",
      country: "Country*",
      city: "City*",
      state_province: "State/Province*",
      zip_code: "Zip Code*",
      consent_contact_title: "Consent to Be Contacted by Schools",
      consent_contact_text: "By opting in, I authorize Explore2Teach to share my application and contact details with school districts looking for educators with my qualifications. Schools may reach out to me via phone, email, or text regarding potential job openings. I can withdraw this consent at any time through my account settings.",
      consent_contact_checkbox: "Yes, I agree to be contacted by schools for job opportunities.",
      receive_job_recommendation_title: "Receive Job Recommendations via Email",
      receive_job_recommendation_text: "Let us help you find the right job! Get personalized job recommendations based on your experience, preferences, and application history.",
      receive_job_recommendation_checkbox: "Yes, I would like to receive job recommendations and career updates via email.",
      subscribe_newsletter_title: "Subscribe to Our Newsletter",
      subscribe_newsletter_checkbox: "Yes, sign me up for the Explore2Teach newsletter.",
      update: "UPDATE",
      next_setup: "Next: Setup your disclosures",
      saving: "Saving...",
      joined: "Joined Jan 2025",

    },
    es: {
      profile_strength: "Fortaleza del perfil",
      update_resume: "Actualizar currículum",
      upload_resume: "Subir currículum",
      update_presentation_video: "Actualizar video de presentación",
      upload_presentation_video: "Subir video de presentación",
      update_lesson_plan: "Actualizar plan de lección",
      upload_lesson_plan: "Subir plan de lección",
      update_certifications: "Actualizar certificaciones",
      upload_certifications: "Subir certificaciones",
      update_recent_evaluation: "Actualizar evaluación reciente",
      upload_recent_evaluation: "Subir evaluación reciente",
      update_references: "Actualizar referencias",
      upload_references: "Subir referencias",
      profile_details: "Detalles del perfil",
      first_name: "Nombre*",
      last_name: "Apellido*",
      email_address: "Correo electrónico*",
      contact_number: "Número de contacto*",
      gender: "Género",
      select_gender: "Seleccionar género",
      male: "Masculino",
      female: "Femenino",
      any: "Cualquiera",
      date_of_birth: "Fecha de nacimiento",
      address: "Dirección*",
      country: "País*",
      city: "Ciudad*",
      state_province: "Estado/Provincia*",
      zip_code: "Código postal*",
      consent_contact_title: "Consentimiento para ser contactado por escuelas",
      consent_contact_text: "Al optar por participar, autorizo a Explore2Teach a compartir mi solicitud y datos de contacto con distritos escolares que buscan educadores con mis calificaciones. Las escuelas pueden comunicarse conmigo por teléfono, correo electrónico o mensaje de texto sobre posibles vacantes laborales. Puedo retirar este consentimiento en cualquier momento desde la configuración de mi cuenta.",
      consent_contact_checkbox: "Sí, acepto ser contactado por escuelas para oportunidades de trabajo.",
      receive_job_recommendation_title: "Recibir recomendaciones de trabajo por correo electrónico",
      receive_job_recommendation_text: "¡Déjanos ayudarte a encontrar el trabajo adecuado! Obtén recomendaciones personalizadas de empleo basadas en tu experiencia, preferencias e historial de solicitudes.",
      receive_job_recommendation_checkbox: "Sí, me gustaría recibir recomendaciones de trabajo y actualizaciones de carrera por correo electrónico.",
      subscribe_newsletter_title: "Suscribirse a nuestro boletín",
      subscribe_newsletter_checkbox: "Sí, suscríbeme al boletín de Explore2Teach.",
      update: "ACTUALIZAR",
      next_setup: "Siguiente: Configura tus divulgaciones",
      saving: "Guardando...",
      joined: "Se unió en enero de 2025",

    }
  },

  upload_resume_modal: {
    en: {
      title: "Upload Resume",
      dragDrop: "Drag & Drop your resume or <span class='filepond--label-action'>Browse</span>",
      currentResume: "Current Resume:",
      close: "Close",
      upload: "Upload"
    },
    es: {
      title: "Subir currículum",
      dragDrop: "Arrastra y suelta tu currículum o <span class='filepond--label-action'>Buscar</span>",
      currentResume: "Currículum actual:",
      close: "Cerrar",
      upload: "Subir"
    }
  },
  upload_presentation_modal: {
    en: {
      title: "Upload Presentation",
      instructionsTitle: "Instructions:",
      instruction1: "Make sure the url can be accessed publicly",
      instruction2: "Presentation must be at least 15 mins of yourself demonstrating your teaching skills",
      label: "Enter the link of your presentation:",
      close: "Close",
      save: "Save"
    },
    es: {
      title: "Subir presentación",
      instructionsTitle: "Instrucciones:",
      instruction1: "Asegúrate de que la URL sea accesible públicamente",
      instruction2: "La presentación debe durar al menos 15 minutos mostrando tus habilidades de enseñanza",
      label: "Ingresa el enlace de tu presentación:",
      close: "Cerrar",
      save: "Guardar"
    }
  },
  uploadLessonPlan: {
    en: {
      title: "Upload Lesson Plan",
      labelIdle: "Drag & Drop your resume or <span class='filepond--label-action'>Browse</span>",
      current: "Current Lesson Plan:",
      close: "Close",
      upload: "Upload"
    },
    es: {
      title: "Subir plan de lección",
      labelIdle: "Arrastra y suelta tu currículum o <span class='filepond--label-action'>Buscar</span>",
      current: "Plan de lección actual:",
      close: "Cerrar",
      upload: "Subir"
    }
  },
  uploadCertifications: {
    en: {
      title: "Upload Certifications",
      instructions: "Instructions:",
      instruction1: "You can upload multiple files at the same time",
      labelIdle: "Drag & Drop your certifications or <span class='filepond--label-action'>Browse</span>",
      current: "Current Certifications:",
      close: "Close",
      upload: "Upload"
    },
    es: {
      title: "Subir certificaciones",
      instructions: "Instrucciones:",
      instruction1: "Puedes subir múltiples archivos al mismo tiempo",
      labelIdle: "Arrastra y suelta tus certificaciones o <span class='filepond--label-action'>Buscar</span>",
      current: "Certificaciones actuales:",
      close: "Cerrar",
      upload: "Subir"
    }
  },
  uploadReferences: {
    en: {
      title: "Upload References",
      instructions: "Instructions:",
      instruction1: "Compile all your references on a doc, docx or pdf format",
      labelIdle: "Drag & Drop your resume or <span class='filepond--label-action'>Browse</span>",
      current: "Current References:",
      close: "Close",
      upload: "Upload"
    },
    es: {
      title: "Subir referencias",
      instructions: "Instrucciones:",
      instruction1: "Compila todas tus referencias en formato doc, docx o pdf",
      labelIdle: "Arrastra y suelta tu currículum o <span class='filepond--label-action'>Buscar</span>",
      current: "Referencias actuales:",
      close: "Cerrar",
      upload: "Subir"
    }
  },
  uploadEvaluation: {
    en: {
      title: "Upload Recent Evaluation",
      instructions: "Instructions:",
      instruction1: "Compile all your evaluations on a doc, docx or pdf format",
      labelIdle: "Drag & Drop your resume or <span class='filepond--label-action'>Browse</span>",
      current: "Current Evaluation:",
      close: "Close",
      upload: "Upload"
    },
    es: {
      title: "Subir evaluación reciente",
      instructions: "Instrucciones:",
      instruction1: "Compila todas tus evaluaciones en formato doc, docx o pdf",
      labelIdle: "Arrastra y suelta tu currículum o <span class='filepond--label-action'>Buscar</span>",
      current: "Evaluación actual:",
      close: "Cerrar",
      upload: "Subir"
    }
  },
  welcomeModal: {
    en: {
      title: "Welcome to Explore2Teach,",
      instruction: "To start, you have to update your profile and preferences and upload all the required documents to apply",
      gotIt: "Got it!"
    },
    es: {
      title: "Bienvenido a Explore2Teach,",
      instruction: "Para comenzar, debes actualizar tu perfil y preferencias y cargar todos los documentos requeridos para postularte",
      gotIt: "¡Entendido!"
    }
  },
  user_dashboard: {
    en: {
      welcome: "Welcome back,",
      journey: "Your teaching journey continues!",
      quickLinks: "Quick Links",
      explore: "Explore",
      teach: "Teach",
      teacherTemplates: "Teacher Templates",
      educatorCertification: "Educators Certification"
    },
    es: {
      welcome: "Bienvenido de nuevo,",
      journey: "¡Tu viaje docente continúa!",
      quickLinks: "Enlaces rápidos",
      explore: "Explorar",
      teach: "Enseñar",
      teacherTemplates: "Plantillas para docentes",
      educatorCertification: "Certificación de educadores"
    }
  },
  user_vacancies: {
    en: {
      home: "Home",
      vacancies: "Vacancies",
      searchPlaceholder: "Search job title here...",
      search: "Search",
      advancedFilter: "Advanced Filter",
      position: "Position",
      schoolName: "School Name",
      lastDateToApply: "Last Date to Apply",
      viewDetails: "View Details",
      previous: "Previous",
      next: "Next",
      page: "Page"
    },
    es: {
      home: "Inicio",
      vacancies: "Vacantes",
      searchPlaceholder: "Buscar título de trabajo aquí...",
      search: "Buscar",
      advancedFilter: "Filtro Avanzado",
      position: "Posición",
      schoolName: "Nombre de la Escuela",
      lastDateToApply: "Última Fecha para Postular",
      viewDetails: "Ver Detalles",
      previous: "Anterior",
      next: "Siguiente",
      page: "Página"
    }
  },
  show_matches: {
    en: {
      hello: "Hello",
      fetching: "We are fetching your job matches",
      topMatches: "Here are your Top Matches",
      school: "School",
      type: "Type",
      viewDetails: "View Details",
      noMatches: "No matches found.",
      updatePreferences: "Update your preferences"
    },
    es: {
      hello: "Hola",
      fetching: "Estamos buscando tus coincidencias de trabajo",
      topMatches: "Aquí están tus mejores coincidencias",
      school: "Escuela",
      type: "Tipo",
      viewDetails: "Ver Detalles",
      noMatches: "No se encontraron coincidencias.",
      updatePreferences: "Actualiza tus preferencias"
    }
  },
  job_filter: {
    en: {
      advancedFilters: "Advanced Job Filters",
      filterBySchool: "Filter by School",
      allSchools: "All Schools",
      educationalLevel: "Educational Level",
      subjectExpertise: "Subject Expertise",
      schoolDesignation: "School Designation",
      resetFilters: "Reset Filters",
      applyFilters: "Apply Filters"
    },
    es: {
      advancedFilters: "Filtros Avanzados de Empleo",
      filterBySchool: "Filtrar por escuela",
      allSchools: "Todas las escuelas",
      educationalLevel: "Nivel educativo",
      subjectExpertise: "Especialización en asignaturas",
      schoolDesignation: "Designación de la escuela",
      resetFilters: "Restablecer filtros",
      applyFilters: "Aplicar filtros"
    }
  },
  user_pageSidebar: {
    en: {
      logout: "Logout",
      dashboard: "Dashboard",
      vacancies: "Vacancies",
      applications: "Applications",
      title: "Explore2Teach",
      year: "2024",
      reserved: "All Rights Reserved",
    },
    es: {
      logout: "Cerrar sesión",
      dashboard: "Panel",
      vacancies: "Vacantes",
      applications: "Solicitudes",
      title: "Explore2Teach",
      year: "2024",
      reserved: "Todos los derechos reservados",
    }
  },
  user_pageHeader: {
    en: {
      profile: "Profile",
      preferences: "Preferences",
      disclosures: "Disclosures",
      logout: "Logout",
    },
    es: {
      profile: "Perfil",
      preferences: "Preferencias",
      disclosures: "Divulgaciones",
      logout: "Cerrar sesión",
    }
  },
  user_pageFooter: {
    en: {
      copyright: "Copyright © Designed",
      developer: "Developed by",
      title: "Explore2Teach ",
      year: "2024",
    },
    es: {
      copyright: "Copyright © Diseñado",
      developer: "Desarrollado por",
      title: "Explore2Teach ",
      year: "2024",
    }

  },
  user_preferences: {
    en: {
      introLine1: "At Explore2Teach, we’re here to support you every step of the way.",
      introLine2: "Tell us a bit about yourself, and we’ll connect you with tailored resources, opportunities, and support to empower your path to the classroom.",
      gradeLevelsTitle: "Grade Levels Interested in Teaching",
      gradeLevelsLabel: "Select all that apply",
      subjectsTitle: "Subjects Expertise",
      subjectsLabel: "Check all that apply",
      others: "Others",
      pleaseSpecify: "Please specify",
      teachingExperienceTitle: "Teaching Experience",
      teachingExperienceDescription: "Do you have teaching experience in any of the following settings?",
      teachingExperienceLabel: "Check all that apply",
      professionalTrainingTitle: "Professional Training and Skills",
      professionalTrainingDescription: "Choose 5 and pick your strongest first:",
      yourTopSkills: "Your Top Skills",
      noSkillsSelected: "No trainings/skills selected",
      submit: "Submit",
      saving: "Saving...",
      completedProfilesNotice: "Only completed profiles will be considered for matching opportunities."
    },
    es: {
      introLine1: "En Explore2Teach, estamos aquí para apoyarte en cada paso del camino.",
      introLine2: "Cuéntanos un poco sobre ti y te conectaremos con recursos, oportunidades y apoyo personalizados para impulsar tu camino hacia el aula.",
      gradeLevelsTitle: "Niveles de grado en los que está interesado en enseñar",
      gradeLevelsLabel: "Seleccione todas las que correspondan",
      subjectsTitle: "Especialización en asignaturas",
      subjectsLabel: "Marque todas las que correspondan",
      others: "Otros",
      pleaseSpecify: "Por favor especifique",
      teachingExperienceTitle: "Experiencia docente",
      teachingExperienceDescription: "¿Tiene experiencia docente en alguno de los siguientes entornos?",
      teachingExperienceLabel: "Marque todas las que correspondan",
      professionalTrainingTitle: "Capacitación y habilidades profesionales",
      professionalTrainingDescription: "Elija 5 y seleccione la más fuerte primero:",
      yourTopSkills: "Sus principales habilidades",
      noSkillsSelected: "No se seleccionaron capacitaciones/habilidades",
      submit: "Enviar",
      saving: "Guardando...",
      completedProfilesNotice: "Solo los perfiles completos serán considerados para oportunidades de emparejamiento."
    }
  },
  user_applicationTable: {
    en: {
      allStatus: "All Status",
      pending: "Pending",
      onHold: "On-Hold",
      candidate: "Candidate",
      newest: "Newest",
      oldest: "Oldest",
      dateApplied: "Date Applied",
      company: "Company",
      type: "Type",
      position: "Position",
      score: "Score",
      status: "Status",
      viewApplication: "View Application",
      cancelApplication: "Cancel Application",
      n_a: "N/A"
    },
    es: {
      allStatus: "Todos los estados",
      pending: "Pendiente",
      onHold: "En espera",
      candidate: "Candidato",
      newest: "Más reciente",
      oldest: "Más antiguo",
      dateApplied: "Fecha de aplicación",
      company: "Compañía",
      type: "Tipo",
      position: "Posición",
      score: "Puntuación",
      status: "Estado",
      viewApplication: "Ver solicitud",
      cancelApplication: "Cancelar solicitud",
      n_a: "N/D"
    }
  },
  resetPassword: {
    en: {
      title: "Reset your password",
      emailLabel: "Email",
      emailPlaceholder: "Enter email",
      submit: "Submit",
      tryLogin: "Try logging in?",
      clickHere: "Click here"
    },
    es: {
      title: "Restablece tu contraseña",
      emailLabel: "Correo electrónico",
      emailPlaceholder: "Ingresa tu correo electrónico",
      submit: "Enviar",
      tryLogin: "¿Intentar iniciar sesión?",
      clickHere: "Haz clic aquí"
    }
  },
  user_disclosures: {
    en: {
      preferences: "Job Preferences",
      profile: "Profile Questions",
      applicantDisclosures: "Applicant Disclosure",
      criminalInformation: "Criminal Information",
      additionalQuestions: "Additional Questions",
      selfIdentification: "Self Identification",
      publicRecordsConsent: "Public Records Consent"
    },
    es: {
      preferences: "Preferencias de trabajo",
      profile: "Preguntas de perfil",
      applicantDisclosures: "Divulgación del solicitante",
      criminalInformation: "Información criminal",
      additionalQuestions: "Preguntas adicionales",
      selfIdentification: "Autoidentificación",
      publicRecordsConsent: "Consentimiento de registros públicos"
    }
  },

  profile_questions: {
    en: {
      profile_q: "Profile Questions",
      yes: "Yes",
      no: "No",
      submit: "Submit",
      authorized: "Are you currently authorized to work in the United States?",
      authorized_note: "Important Note: The Social Security Number must be valid.",
      citizen: "Are you a citizen or permanent resident of the United States?",
      sponsorship: "Do you require sponsorship to work in the United States?",
      work_auth: "Do you have a valid work authorization?",
      work_auth_note: "If you currently have work authorization, upload a copy of the front and back of the work authorization card.",
      work_auth_warning: "*Please be aware that we may request to have you bring the card to our office.",
      current_employee: "Are you a CURRENT employee of a school in any of the counties below?",
      expiration_date: "Expiration Date:",
      previoesly_uploaded: "Previously Uploaded Files:",
      hillsborough: "Hillsborough County School",
      pinellas: "Pinellas County School",
      former_employee: "Have you EVER accepted a job for, or EVER worked for schools in any of the counties below? If this answer is \"yes,\" your experience must be listed in the Work Experience Section of this application.",
      charter_note: "NOTE: ",
      charter_note2: "Charter School employees are NOT considered employees.",
      list_note: "If yes, please list the following:",
      list_1: "Your employee number",
      list_2: "The dates of your employment (from and to)",
      list_3: "Title of the position that you held",
      provide_details: "Provide details:",
      substitute_2014: "Were you a Substitute Teacher to any of the following schools up until 2014?",
      substitute_after_2014: "Have you been a substitute teacher to any of the following county?",
      kelly_sub: "Are you currently participating in a J1 Visa cultural exchange program.",
      kelly_note: "If yes, this must be listed in your work experience.",
      relative: "Are you a family member of a current employee of the following schools?",
      relative_note: "If yes, please provide the name of the relative and your relationship to them.",
      hillsborough_title: "Hillsborough County School",
      hillsborough_yes: "Yes",
      hillsborough_no: "No",
      hillsborough_relative_name: "Relative's Name",
      hillsborough_relative_name_placeholder: "Enter relative's name",
      hillsborough_relationship: "Relationship",
      hillsborough_relationship_placeholder: "Enter your relationship",

      pinellas_title: "Pinellas County School",
      pinellas_yes: "Yes",
      pinellas_no: "No",
      pinellas_relative_name: "Relative's Name",
      pinellas_relative_name_placeholder: "Enter relative's name",
      pinellas_relationship: "Relationship",
      pinellas_relationship_placeholder: "Enter your relationship",

      speak_english: "Do you speak English?",
      write_english: "Do you write in English?",

      speak_other_language: "Do you speak a language other than English?",
      speak_other_language_specify: "Please specify the language",
      speak_other_language_placeholder: "Enter language",

      write_other_language: "Do you write in a language other than English?",
      write_other_language_specify: "Please specify the language",
      write_other_language_placeholder: "Enter language",

      dual_language_teaching: "If applying for teaching positions, are you interested in dual language teaching opportunities?",

      frs_pension: "Are you currently receiving a monthly pension from the Florida Retirement System (FRS)?",
      frs_distribution: "Have you EVER received an Investment Plan distribution payment from the Florida Retirement System (FRS)?",
      other_pension: "Are you CURRENTLY receiving any pension or retirement payment from ANY previous employers?",

      total_years_experience: "How many TOTAL years of public school-based administrative experience, public school teaching experience, or public school paraprofessional/support experience do you have?",
      total_years_experience_placeholder: "Enter number of years",

      other_retirement_plan: "Have you EVER retired from or received any money from another school district’s retirement plan? If 'yes,' please list when (date) and from where. In addition, please list the name of the retirement plan (i.e., DROP, Investment, Pension, or other - please explain).",
      other_retirement_plan_details: "Enter details: date, district, and plan name",

      retired_responder: "Are you a retired First Responder (Firefighter or Paramedic)? If 'yes,' please explain.",
      retired_responder_details: "Provide details of your service",
    },
    es: {
      profile_q: "Preguntas de Perfil",
      yes: "Sí",
      no: "No",
      submit: "Enviar",
      authorized: "¿Está actualmente autorizado para trabajar en los Estados Unidos?",
      authorized_note: "Nota importante: El número de Seguro Social debe ser válido.",
      citizen: "¿Es usted ciudadano o residente permanente de los Estados Unidos?",
      sponsorship: "¿Necesita patrocinio para trabajar en los Estados Unidos?",
      work_auth: "Tengo autorización de trabajo que tiene una fecha de vencimiento (ingrese la fecha):",
      work_auth_note: "Si actualmente tiene autorización de trabajo, cargue una copia del frente y reverso de la tarjeta de autorización de trabajo.",
      work_auth_warning: "*Tenga en cuenta que podemos solicitar que traiga la tarjeta a nuestra oficina.",
      current_employee: "¿Es usted un empleado ACTUAL de una escuela en cualquiera de los siguientes condados?",
      expiration_date: "Fecha de vencimiento:",
      previoesly_uploaded: "Archivos cargados previamente:",
      hillsborough: "Escuela del Condado de Hillsborough",
      pinellas: "Escuela del Condado de Pinellas",
      former_employee: "¿Alguna vez ha aceptado un trabajo o ha trabajado en escuelas de cualquiera de los siguientes condados? Si la respuesta es \"sí\", su experiencia debe estar listada en la sección de Experiencia Laboral de esta solicitud.",
      charter_note: "NOTA:",
      charter_note2: "Los empleados de escuelas chárter NO se consideran empleados.",
      list_note: "Si es así, por favor indique lo siguiente:",
      list_1: "Su número de empleado",
      list_2: "Las fechas de su empleo (desde y hasta)",
      list_3: "Título del puesto que ocupó",
      provide_details: "Proporcione detalles:",
      substitute_2014: "¿Fue usted maestro sustituto en alguna de las siguientes escuelas?",
      substitute_after_2014: "¿Has sido maestro sustituto en alguno de los siguientes condados después de 2014?",
      kelly_sub: "¿Actualmente participa en un programa de intercambio cultural con visa J1?",
      kelly_note: "Si es así, esto debe estar listado en su experiencia laboral.",
      relative: "¿Es usted familiar de un empleado actual de las siguientes escuelas?",
      relative_note: "Si es así, proporcione el nombre del familiar y su relación con él.",

      hillsborough_title: "Escuela del Condado de Hillsborough",
      hillsborough_yes: "Sí",
      hillsborough_no: "No",
      hillsborough_relative_name: "Nombre del Familiar",
      hillsborough_relative_name_placeholder: "Ingrese el nombre del familiar",
      hillsborough_relationship: "Relación",
      hillsborough_relationship_placeholder: "Ingrese su relación",

      pinellas_title: "Escuela del Condado de Pinellas",
      pinellas_yes: "Sí",
      pinellas_no: "No",
      pinellas_relative_name: "Nombre del Familiar",
      pinellas_relative_name_placeholder: "Ingrese el nombre del familiar",
      pinellas_relationship: "Relación",
      pinellas_relationship_placeholder: "Ingrese su relación",

      speak_english: "¿Habla inglés?",
      write_english: "¿Escribe en inglés?",

      speak_other_language: "¿Habla un idioma que no sea inglés?",
      speak_other_language_specify: "Por favor, especifique el idioma",
      speak_other_language_placeholder: "Ingrese el idioma",

      write_other_language: "¿Escribe en un idioma que no sea inglés?",
      write_other_language_specify: "Por favor, especifique el idioma",
      write_other_language_placeholder: "Ingrese el idioma",

      dual_language_teaching: "Si está solicitando un puesto de enseñanza, ¿está interesado en oportunidades de enseñanza bilingüe?",

      frs_pension: "¿Actualmente recibe una pensión mensual del Sistema de Jubilación de Florida (FRS)?",
      frs_distribution: "¿Alguna vez ha recibido un pago de distribución del Plan de Inversión del Sistema de Jubilación de Florida (FRS)?",
      other_pension: "¿ACTUALMENTE recibe alguna pensión o pago de jubilación de ALGÚN empleador anterior?",

      total_years_experience: "¿Cuántos años TOTALES de experiencia administrativa escolar pública, experiencia docente en escuela pública o experiencia como paraprofesional/personal de apoyo en escuela pública tiene?",
      total_years_experience_placeholder: "Ingrese el número de años",

      other_retirement_plan: "¿Alguna vez se ha jubilado o ha recibido dinero de otro plan de jubilación de un distrito escolar? Si es 'sí', indique cuándo (fecha) y de dónde. Además, indique el nombre del plan de jubilación (por ejemplo, DROP, Inversión, Pensión u otro - por favor explique).",
      other_retirement_plan_details: "Ingrese los detalles: fecha, distrito y nombre del plan",

      retired_responder: "¿Es usted un Primer Respondedor jubilado (Bombero o Paramédico)? Si es 'sí', por favor explique.",
      retired_responder_details: "Proporcione detalles de su servicio",
    }

  },
  disclosure: {
    en: {
      yes: "Yes",
      no: "No",
      employment_disclosure_title: "EMPLOYMENT DISCLOSURE INFORMATION AND DETAILS",
      termination: "Have you ever been dismissed, fired, terminated, or suspended from a position?",
      contract_not_renewed: "Have you ever had a contract non-renewed or been asked to resign from a position?",
      certificate_sanction: "Have you ever had a certificate or license revoked, suspended, or sanctioned by a licensing agency?",
      criminal_offense: "Have you ever been convicted, pleaded guilty, or pleaded no contest to any criminal offense?",
      pending_investigation: "Are you currently under investigation or subject to disciplinary action by any organization?",
      misconduct_investigation: "Have you ever been the subject of an investigation for alleged misconduct in a professional setting?",
      additional_date: "Date",
      additional_location: "City and State",
      additional_organization: "Company, School District, State Dept., etc.",
      additional_outcome: "Action Taken/Outcome",
      button_submit: "Submit",
      placeholder1: "Enter outcome",
      placeholder2: "Enter details",
      placeholder3: "Enter city and state",
    },
    es: {
      yes: "Sí",
      no: "No",
      employment_disclosure_title: "DIVULGACIÓN DE INFORMACIÓN Y DETALLES DE EMPLEO",
      termination: "¿Alguna vez ha sido despedido, cesado, terminado o suspendido de un puesto?",
      contract_not_renewed: "¿Alguna vez no le han renovado un contrato o le han pedido que renuncie a un puesto?",
      certificate_sanction: "¿Alguna vez le han revocado, suspendido o sancionado una certificación o licencia por parte de una agencia reguladora?",
      criminal_offense: "¿Alguna vez ha sido condenado, se ha declarado culpable o no impugnó ningún delito penal?",
      pending_investigation: "¿Actualmente está bajo investigación o sujeto a acción disciplinaria por parte de alguna organización?",
      misconduct_investigation: "¿Alguna vez ha sido objeto de una investigación por presunta mala conducta en un entorno profesional?",
      additional_date: "Fecha",
      additional_location: "Ciudad y Estado",
      additional_organization: "Empresa, Distrito Escolar, Departamento Estatal, etc.",
      additional_outcome: "Acción tomada/Resultado",
      button_submit: "Enviar",
      placeholder1: "Ingrese el resultado",
      placeholder2: "Ingrese los detalles",
      placeholder3: "Ingrese ciudad y estado"
    }


  },
  criminalInformation: {
    en: {
      yes: "Yes",
      no: "No",
      criminal_background_title: "Criminal Background Questions",
      on_probation_question: "Are you currently on probation or currently under any imposed requirements for charges other than a minor traffic violation? (A DUI and criminal traffic offenses are not considered \"minor\" traffic violations and must be disclosed).",
      pending_charge_question: "Is there any criminal charge now pending against you other than a minor traffic violation? (A DUI and criminal traffic offenses are not considered \"minor\" traffic violations and must be disclosed).",
      ever_arrested_question: "Have you EVER been arrested or charged for a criminal offense? Note: A DUI and criminal traffic offenses are criminal offenses and must be disclosed. These are not considered \"minor offenses.\"",
      child_abuse_question: "Have you ever had any filing or finding of child abuse filed in your name or an alias?",
      sex_offender_question: "Does your name appear on any Sex Offender Database in any state or country?",
      additional_date_label: "Date of the Occurrence",
      additional_city_label: "City of the Occurrence",
      additional_explanation_label: "Nature of Charges(s)/Explanation of Events",
      button_submit: "Submit"
    },
    es: {
      yes: "Sí",
      no: "No",
      criminal_background_title: "Preguntas sobre Antecedentes Penales",
      on_probation_question: "¿Actualmente está en libertad condicional o bajo algún requisito impuesto por cargos que no sean una infracción menor de tránsito? (Un DUI y las infracciones penales de tránsito no se consideran infracciones \"menores\" y deben ser divulgadas).",
      pending_charge_question: "¿Tiene actualmente algún cargo penal pendiente en su contra que no sea una infracción menor de tránsito? (Un DUI y las infracciones penales de tránsito no se consideran infracciones \"menores\" y deben ser divulgadas).",
      ever_arrested_question: "¿Alguna vez ha sido arrestado o acusado de un delito penal? Nota: Un DUI y las infracciones penales de tránsito son delitos penales y deben ser divulgados. No se consideran \"infracciones menores\".",
      child_abuse_question: "¿Alguna vez ha tenido alguna acusación o hallazgo de abuso infantil presentado a su nombre o bajo un alias?",
      sex_offender_question: "¿Su nombre aparece en alguna base de datos de delincuentes sexuales en algún estado o país?",
      additional_date_label: "Fecha del Suceso",
      additional_city_label: "Ciudad del Suceso",
      additional_explanation_label: "Naturaleza del/los cargo(s)/Explicación de los hechos",
      button_submit: "Enviar"
    }

  },
  additional_questions: {
    en: {
      yes: "Yes",
      no: "No",
      teaching_certification_title: "Teaching Certification Questions",
      florida_certificate_question: "Do you hold or anticipate a Florida certificate?",
      other_state_certificate_question: "Do you currently hold a valid teaching certificate issued by a state other than Florida?",
      name_the_program_placeholder: "Name the programs",
      eligibility_question: "Do you currently hold a statement of eligibility with the state of Florida?",
      teacher_prep_program_question: "If not currently certified, are you enrolled in a teacher preparatory program?",
      nbpts_question: "Do you currently hold National Board for Professional Teaching Standards certification?",
      general_knowledge_exam_question: "If you checked not holding a permanent certificate, and you have a temporary certificate, have you passed all sections of the Florida Teacher General Knowledge Exam",
      teaching_internship_question: "Did you complete a teaching internship? if yes, please list where the internship was completed (in what county or state).",
      internship_placeholder: "Where was the internship completed? (County/State)",
      current_intern_question: "Are you a current intern for any of the following counties?",
      hillsborough_intern_label: "Hillborough County Public School",
      pinellas_intern_label: "Pinellas County School",
      button_submit: "Submit"
    },
    es: {
      yes: "Sí",
      no: "No",
      teaching_certification_title: "Preguntas sobre Certificación Docente",
      florida_certificate_question: "¿Posee o anticipa obtener un certificado de Florida?",
      other_state_certificate_question: "¿Posee actualmente un certificado de enseñanza válido emitido por un estado que no sea Florida?",
      name_the_program_placeholder: "Nombre del programa",
      eligibility_question: "¿Posee actualmente una declaración de elegibilidad con el estado de Florida?",
      teacher_prep_program_question: "Si no está certificado actualmente, ¿está inscrito en un programa de preparación docente?",
      nbpts_question: "¿Posee actualmente una certificación de la Junta Nacional de Estándares Profesionales de Enseñanza (NBPTS)?",
      general_knowledge_exam_question: "Si marcó que no posee un certificado permanente y tiene un certificado temporal, ¿ha aprobado todas las secciones del Examen de Conocimientos Generales para Maestros de Florida?",
      teaching_internship_question: "¿Completó una pasantía docente? Si es así, indique dónde se completó la pasantía (en qué condado o estado).",
      internship_placeholder: "¿Dónde se completó la pasantía? (Condado/Estado)",
      current_intern_question: "¿Es usted un pasante actual en alguno de los siguientes?",
      hillsborough_intern_label: "Escuelas Públicas del Condado de Hillsborough",
      pinellas_intern_label: "Escuelas del Condado de Pinellas",
      button_submit: "Enviar"
    }

  },
  self_identification: {
    en: {
      self_identification_title: "SELF IDENTIFICATION",
      self_identification_intro: "Government agencies require us to collect information and file periodic reports regarding the gender, race and /or ethnicity of applicants. The data collected enables us to analyze our hiring processes, and to ensure equal employment opportunity. The information requested below is voluntary and will not be available to individuals involved in the hiring process. This information is kept separate from your application so that it remains confidential.",
      select_ethnicity_label: "*Please select your ethnicity",
      hispanic_latino_origin_label: "Hispanic Or Latino Origin",
      select_ethnicity_placeholder: "Select your ethnicity",
      option_ethnicity_asian: "Asian",
      option_ethnicity_black: "Black",
      option_ethnicity_hispanic: "Hispanic",
      option_ethnicity_native_american: "American Indian / Alaskan Native",
      option_ethnicity_two_or_more: "Two or More Races",
      option_ethnicity_pacific_islander: "Native Hawaiian / Other Pacific Islander",
      option_ethnicity_white: "White",
      option_ethnicity_none_selected: "None Selected",
      select_gender_label: "*Please indicate your gender",
      select_gender_placeholder: "Select your gender",
      option_gender_male: "Male",
      option_gender_female: "Female",
      option_gender_other: "Other",
      option_gender_prefer_not: "Prefer not to say",
      select_veteran_label: "*Please select your Veteran Status",
      select_veteran_placeholder: "Select your veteran status",
      option_veteran_not_veteran: "Not a Veteran",
      option_veteran_veteran: "Veteran",
      option_veteran_disabled_veteran: "Disabled Veteran",
      option_veteran_prefer_not: "Prefer not to say",
      confidentiality_notice: "THE INFORMATION PROVIDED ON THIS FORM WILL BE KEPT SEPARATE FROM YOUR APPLICATION FILE AND WILL NOT BE USED FOR ANY DECISIONS REGARDING THE TERMS AND/OR CONDITIONS OF YOUR EMPLOYMENT. THANK YOU.",
      button_submit: "Submit"
    },
    es: {
      self_identification_title: "AUTOIDENTIFICACIÓN",
      self_identification_intro: "Las agencias gubernamentales requieren que recopilemos información y presentemos informes periódicos sobre el género, la raza y/o la etnia de los solicitantes. Los datos recopilados nos permiten analizar nuestros procesos de contratación y garantizar la igualdad de oportunidades de empleo. La información solicitada a continuación es voluntaria y no estará disponible para las personas involucradas en el proceso de contratación. Esta información se mantiene separada de su solicitud para que permanezca confidencial.",
      select_ethnicity_label: "*Por favor seleccione su etnia",
      hispanic_latino_origin_label: "Origen Hispano o Latino",
      select_ethnicity_placeholder: "Seleccione su etnia",
      option_ethnicity_asian: "Asiático",
      option_ethnicity_black: "Negro o Afroamericano",
      option_ethnicity_hispanic: "Hispano",
      option_ethnicity_native_american: "Indígena Americano / Nativo de Alaska",
      option_ethnicity_two_or_more: "Dos o más razas",
      option_ethnicity_pacific_islander: "Nativo de Hawái / Otro Isleño del Pacífico",
      option_ethnicity_white: "Blanco",
      option_ethnicity_none_selected: "Ninguna seleccionada",
      select_gender_label: "*Por favor indique su género",
      select_gender_placeholder: "Seleccione su género",
      option_gender_male: "Masculino",
      option_gender_female: "Femenino",
      option_gender_other: "Otro",
      option_gender_prefer_not: "Prefiero no decirlo",
      select_veteran_label: "*Por favor seleccione su estatus de veterano",
      select_veteran_placeholder: "Seleccione su estatus de veterano",
      option_veteran_not_veteran: "No soy veterano",
      option_veteran_veteran: "Veterano",
      option_veteran_disabled_veteran: "Veterano discapacitado",
      option_veteran_prefer_not: "Prefiero no decirlo",
      confidentiality_notice: "LA INFORMACIÓN PROPORCIONADA EN ESTE FORMULARIO SE MANTENDRÁ SEPARADA DE SU EXPEDIENTE DE SOLICITUD Y NO SE UTILIZARÁ PARA NINGUNA DECISIÓN RELACIONADA CON LAS CONDICIONES DE SU EMPLEO. GRACIAS.",
      button_submit: "Enviar"
    }

  },

  public_records_consent: {
    en: {
      public_records_title: "PUBLIC RECORDS LAW",
      public_records_subtitle: "Public Records Law, Chapter 119.07",
      public_records_intro: "Florida law establishes certain employee information as a public record. Information concerning certain employees is excluded from release in accordance with the public records law.",
      public_records_instruction: "Please read the following and indicate whether or not you are:",
      public_records_point_1: "Within one of the categories listed below, or",
      public_records_point_2: "The spouse or child of someone within one of the categories listed below",
      public_records_list_1: "Active or former law enforcement personnel, including correctional and correctional probation officers, personnel of the Department of Children and Family Services whose duties include the investigation of abuse, neglect, exploitation, fraud, theft, or other criminal activities, personnel of the Department of Health whose duties are to support the investigation of child abuse or neglect, personnel of the Department of Revenue or local government whose responsibilities include revenue collection and enforcement or child support enforcement;",
      public_records_list_2: "Firefighters certified in compliance with s. 633.35;",
      public_records_list_3: "Justices of the Supreme Court, district court of appeal judges, circuit court judges, and county court judges;",
      public_records_list_4: "Current or former state attorneys, assistant state attorneys, statewide prosecutors or assistant statewide prosecutors;",
      public_records_list_5: "General magistrates, special magistrates, judges of compensation claims, administrative law judges of the Division of Administrative Hearings, and child support enforcement hearing officers;",
      public_records_list_6: "Current or former human resource, labor relations, employee relations directors, assistant directors, managers, or assistant managers of any local government agency or water management district whose duties include hiring and firing employees, labor contract negotiation, administration or other personnel-related duties;",
      public_records_list_7: "Current or former United States attorneys and assistant United States attorneys;",
      public_records_list_8: "Current or former judges of United States Courts of Appeal, United States district judges and United States magistrate judges;",
      public_records_list_9: "Current or former code enforcement officers;",
      public_records_list_10: "Current or former guardians ad litem, as defined in s. 39.820;",
      public_records_list_11: "Current or former juvenile probation officers, juvenile probation supervisors, detention superintendents and assistant detention superintendents, senior juvenile detention officers, juvenile detention officer supervisors, juvenile detention officers, house parents I and II, house parent supervisors, group treatment leaders, group treatment leader supervisors, rehabilitation therapists, social services counselors of the Department of Juvenile Justice.",
      public_records_permission_label: "I give permission to release my public record information.",
      option_yes: "Yes",
      option_no: "No",
      button_submit: "Submit"
    },
    es: {
      public_records_title: "LEY DE REGISTROS PÚBLICOS",
      public_records_subtitle: "Ley de Registros Públicos, Capítulo 119.07",
      public_records_intro: "La ley de Florida establece que cierta información de los empleados es un registro público. La información referente a ciertos empleados está excluida de la divulgación de acuerdo con la ley de registros públicos.",
      public_records_instruction: "Por favor, lea lo siguiente e indique si usted es:",
      public_records_point_1: "Parte de una de las categorías que se enumeran a continuación, o",
      public_records_point_2: "El cónyuge o hijo de alguien dentro de una de las categorías que se enumeran a continuación",
      public_records_list_1: "Personal activo o retirado de las fuerzas del orden, incluidos oficiales de correcciones y de libertad condicional correccional, personal del Departamento de Niños y Familias cuyas funciones incluyen la investigación de abuso, negligencia, explotación, fraude, robo u otras actividades criminales, personal del Departamento de Salud cuyas funciones son apoyar la investigación de abuso o negligencia infantil, personal del Departamento de Ingresos o del gobierno local cuyas responsabilidades incluyen la recaudación y cumplimiento de ingresos o el cumplimiento de la manutención infantil;",
      public_records_list_2: "Bomberos certificados en cumplimiento con s. 633.35;",
      public_records_list_3: "Jueces de la Corte Suprema, jueces de tribunales de apelaciones de distrito, jueces de tribunales de circuito y jueces de tribunales del condado;",
      public_records_list_4: "Fiscales estatales actuales o anteriores, fiscales adjuntos, fiscales generales estatales o fiscales generales adjuntos;",
      public_records_list_5: "Magistrados generales, magistrados especiales, jueces de reclamaciones de compensación, jueces de derecho administrativo de la División de Audiencias Administrativas y oficiales de audiencias de cumplimiento de manutención infantil;",
      public_records_list_6: "Directores, subdirectores, gerentes o subgerentes actuales o anteriores de recursos humanos, relaciones laborales o relaciones con empleados de cualquier agencia gubernamental local o distrito de gestión del agua cuyas funciones incluyen la contratación y despido de empleados, la negociación de contratos laborales, la administración u otras funciones relacionadas con el personal;",
      public_records_list_7: "Fiscales de los Estados Unidos y fiscales adjuntos de los Estados Unidos actuales o anteriores;",
      public_records_list_8: "Jueces actuales o anteriores de tribunales de apelaciones de los Estados Unidos, jueces de distrito de los Estados Unidos y magistrados de los Estados Unidos;",
      public_records_list_9: "Oficiales de cumplimiento del código actuales o anteriores;",
      public_records_list_10: "Guardianes ad litem actuales o anteriores, según se define en s. 39.820;",
      public_records_list_11: "Oficiales de libertad condicional juvenil, supervisores de libertad condicional juvenil, superintendentes de detención y sub-superintendentes de detención, oficiales superiores de detención juvenil, supervisores de oficiales de detención juvenil, oficiales de detención juvenil, padres de hogar I y II, supervisores de padres de hogar, líderes de tratamiento grupal, supervisores de líderes de tratamiento grupal, terapeutas de rehabilitación, consejeros de servicios sociales del Departamento de Justicia Juvenil actuales o anteriores.",
      public_records_permission_label: "¿Doy permiso para divulgar mi información de registro público?",
      option_yes: "Sí",
      option_no: "No",
      button_submit: "Enviar"
    }


  },
  viewJob: {
    en: {
      overview: "Overview",
      job_title: "Job Title:",
      availability: "Availability:",
      posted_date: "Posted Date:",
      last_apply_date: "Last Apply Date:",
      apply_now: "Apply Now",
      view_application: "View Application",
      description: "Description",
      requirements: "Requirements",
      apply_for: "Apply for",
      requirements_checklist: "Requirements Checklist:",
      resume: "Resume:",
      presentation_video: "Presentation Video:",
      sample_lesson_plan: "Sample Lesson Plan:",
      certifications: "Certifications:",
      recent_evaluation: "Recent Evaluation:",
      references: "References:",
      congrats_eligible: "Congratulations, you are eligible to apply!",
      complete_profile: "You need to complete your profile to apply.",
      update_profile: "Update Profile",
      apply: "Apply"
    },
    es: {
      overview: "Resumen",
      job_title: "Título del Puesto:",
      availability: "Disponibilidad:",
      posted_date: "Fecha de Publicación:",
      last_apply_date: "Última Fecha para Postularse:",
      apply_now: "Postular Ahora",
      view_application: "Ver Solicitud",
      description: "Descripción",
      requirements: "Requisitos",
      apply_for: "Postular para",
      requirements_checklist: "Lista de Verificación de Requisitos:",
      resume: "Currículum:",
      presentation_video: "Video de Presentación:",
      sample_lesson_plan: "Plan de Lección de Muestra:",
      certifications: "Certificaciones:",
      recent_evaluation: "Evaluación Reciente:",
      references: "Referencias:",
      congrats_eligible: "¡Felicidades, eres elegible para postularte!",
      complete_profile: "Necesitas completar tu perfil para postularte.",
      update_profile: "Actualizar Perfil",
      apply: "Postular"
    }

  },

  view_application: {
    en: {
      applicant_data: "Applicant Data",
      position: "Position:",
      school_name: "School Name:",
      date_applied: "Date Applied:",
      status: "Status:",
      resume: "Resume:",
      presentation: "Presentation:",
      lesson_plan: "Lesson Plan:",
      certifications: "Certifications:",
      references: "References:",
      improve_resume: "Give me insight to improve my resume",
      reviewing_resume: "Please wait while we review your resume.",
      qualification_score: "Qualification Score",
      matched_percentage: "You are ",
      matched_percentage2: "% matched to this job.",
      insights_improvements: "Insights & Improvements"
    },
    es: {
      applicant_data: "Datos del Candidato",
      position: "Puesto:",
      school_name: "Nombre de la Escuela:",
      date_applied: "Fecha de Postulación:",
      status: "Estado:",
      resume: "Currículum:",
      presentation: "Presentación:",
      lesson_plan: "Plan de Lección:",
      certifications: "Certificaciones:",
      references: "Referencias:",
      improve_resume: "Dame sugerencias para mejorar mi currículum",
      reviewing_resume: "Por favor espera mientras revisamos tu currículum.",
      qualification_score: "Puntuación de Calificación",
      matched_percentage: "Tienes un ",
      matched_percentage2: "% de coincidencia con este trabajo.",
      insights_improvements: "Sugerencias y Mejoras"
    }


  }

}
